"use strict";

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
  * Native JavaScript for Bootstrap v4.2.0 (https://thednp.github.io/bootstrap.native/)
  * Copyright 2015-2022 © dnp_theme
  * Licensed under MIT (https://github.com/thednp/bootstrap.native/blob/master/LICENSE)
  */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.BSN = factory());
})(void 0, function () {
  'use strict';
  /** @type {Record<string, any>} */

  var EventRegistry = {};
  /**
   * The global event listener.
   *
   * @type {EventListener}
   * @this {EventTarget}
   */

  function globalListener(e) {
    var that = this;
    var type = e.type;

    _toConsumableArray(EventRegistry[type]).forEach(function (elementsMap) {
      var _elementsMap = _slicedToArray(elementsMap, 2),
          element = _elementsMap[0],
          listenersMap = _elementsMap[1];
      /* istanbul ignore else */


      if (element === that) {
        _toConsumableArray(listenersMap).forEach(function (listenerMap) {
          var _listenerMap = _slicedToArray(listenerMap, 2),
              listener = _listenerMap[0],
              options = _listenerMap[1];

          listener.apply(element, [e]);

          if (options && options.once) {
            removeListener(element, type, listener, options);
          }
        });
      }
    });
  }
  /**
   * Register a new listener with its options and attach the `globalListener`
   * to the target if this is the first listener.
   *
   * @type {Listener.ListenerAction<EventTarget>}
   */


  var addListener = function addListener(element, eventType, listener, options) {
    // get element listeners first
    if (!EventRegistry[eventType]) {
      EventRegistry[eventType] = new Map();
    }

    var oneEventMap = EventRegistry[eventType];

    if (!oneEventMap.has(element)) {
      oneEventMap.set(element, new Map());
    }

    var oneElementMap = oneEventMap.get(element); // get listeners size

    var size = oneElementMap.size; // register listener with its options

    oneElementMap.set(listener, options); // add listener last

    if (!size) {
      element.addEventListener(eventType, globalListener, options);
    }
  };
  /**
   * Remove a listener from registry and detach the `globalListener`
   * if no listeners are found in the registry.
   *
   * @type {Listener.ListenerAction<EventTarget>}
   */


  var removeListener = function removeListener(element, eventType, listener, options) {
    // get listener first
    var oneEventMap = EventRegistry[eventType];
    var oneElementMap = oneEventMap && oneEventMap.get(element);
    var savedOptions = oneElementMap && oneElementMap.get(listener); // also recover initial options

    var _ref = savedOptions !== undefined ? savedOptions : {
      options: options
    },
        eventOptions = _ref.options; // unsubscribe second, remove from registry


    if (oneElementMap && oneElementMap.has(listener)) oneElementMap["delete"](listener);
    if (oneEventMap && (!oneElementMap || !oneElementMap.size)) oneEventMap["delete"](element);
    if (!oneEventMap || !oneEventMap.size) delete EventRegistry[eventType]; // remove listener last

    /* istanbul ignore else */

    if (!oneElementMap || !oneElementMap.size) {
      element.removeEventListener(eventType, globalListener, eventOptions);
    }
  };
  /**
   * Advanced event listener based on subscribe / publish pattern.
   * @see https://www.patterns.dev/posts/classic-design-patterns/#observerpatternjavascript
   * @see https://gist.github.com/shystruk/d16c0ee7ac7d194da9644e5d740c8338#file-subpub-js
   * @see https://hackernoon.com/do-you-still-register-window-event-listeners-in-each-component-react-in-example-31a4b1f6f1c8
   */


  var Listener = {
    on: addListener,
    off: removeListener,
    globalListener: globalListener,
    registry: EventRegistry
  };
  /**
   * A global namespace for `click` event.
   * @type {string}
   */

  var mouseclickEvent = 'click';
  /**
   * A global namespace for 'transitionend' string.
   * @type {string}
   */

  var transitionEndEvent = 'transitionend';
  /**
   * A global namespace for 'transitionDelay' string.
   * @type {string}
   */

  var transitionDelay = 'transitionDelay';
  /**
   * A global namespace for `transitionProperty` string for modern browsers.
   *
   * @type {string}
   */

  var transitionProperty = 'transitionProperty';
  /**
   * Shortcut for `window.getComputedStyle(element).propertyName`
   * static method.
   *
   * * If `element` parameter is not an `HTMLElement`, `getComputedStyle`
   * throws a `ReferenceError`.
   *
   * @param {HTMLElement} element target
   * @param {string} property the css property
   * @return {string} the css property value
   */

  function getElementStyle(element, property) {
    var computedStyle = getComputedStyle(element); // must use camelcase strings,
    // or non-camelcase strings with `getPropertyValue`

    return property.includes('--') ? computedStyle.getPropertyValue(property) : computedStyle[property];
  }
  /**
   * Utility to get the computed `transitionDelay`
   * from Element in miliseconds.
   *
   * @param {HTMLElement} element target
   * @return {number} the value in miliseconds
   */


  function getElementTransitionDelay(element) {
    var propertyValue = getElementStyle(element, transitionProperty);
    var delayValue = getElementStyle(element, transitionDelay);
    var delayScale = delayValue.includes('ms') ?
    /* istanbul ignore next */
    1 : 1000;
    var duration = propertyValue && propertyValue !== 'none' ? parseFloat(delayValue) * delayScale : 0;
    return !Number.isNaN(duration) ? duration :
    /* istanbul ignore next */
    0;
  }
  /**
   * A global namespace for 'transitionDuration' string.
   * @type {string}
   */


  var transitionDuration = 'transitionDuration';
  /**
   * Utility to get the computed `transitionDuration`
   * from Element in miliseconds.
   *
   * @param {HTMLElement} element target
   * @return {number} the value in miliseconds
   */

  function getElementTransitionDuration(element) {
    var propertyValue = getElementStyle(element, transitionProperty);
    var durationValue = getElementStyle(element, transitionDuration);
    var durationScale = durationValue.includes('ms') ?
    /* istanbul ignore next */
    1 : 1000;
    var duration = propertyValue && propertyValue !== 'none' ? parseFloat(durationValue) * durationScale : 0;
    return !Number.isNaN(duration) ? duration :
    /* istanbul ignore next */
    0;
  }
  /**
   * Shortcut for the `Element.dispatchEvent(Event)` method.
   *
   * @param {HTMLElement} element is the target
   * @param {Event} event is the `Event` object
   */


  var dispatchEvent = function dispatchEvent(element, event) {
    return element.dispatchEvent(event);
  };
  /**
   * Utility to make sure callbacks are consistently
   * called when transition ends.
   *
   * @param {HTMLElement} element target
   * @param {EventListener} handler `transitionend` callback
   */


  function emulateTransitionEnd(element, handler) {
    var called = 0;
    var endEvent = new Event(transitionEndEvent);
    var duration = getElementTransitionDuration(element);
    var delay = getElementTransitionDelay(element);

    if (duration) {
      /**
       * Wrap the handler in on -> off callback
       * @type {EventListener} e Event object
       */
      var transitionEndWrapper = function transitionEndWrapper(e) {
        /* istanbul ignore else */
        if (e.target === element) {
          handler.apply(element, [e]);
          element.removeEventListener(transitionEndEvent, transitionEndWrapper);
          called = 1;
        }
      };

      element.addEventListener(transitionEndEvent, transitionEndWrapper);
      setTimeout(function () {
        /* istanbul ignore next */
        if (!called) dispatchEvent(element, endEvent);
      }, duration + delay + 17);
    } else {
      handler.apply(element, [endEvent]);
    }
  }
  /**
   * Checks if an object is a `Node`.
   *
   * @param {any} node the target object
   * @returns {boolean} the query result
   */


  var isNode = function isNode(element) {
    return element && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].some(function (x) {
      return +element.nodeType === x;
    }) || false;
  };
  /**
   * Check if a target object is `Window`.
   * => equivalent to `object instanceof Window`
   *
   * @param {any} object the target object
   * @returns {boolean} the query result
   */


  var isWindow = function isWindow(object) {
    return object && object.constructor.name === 'Window' || false;
  };
  /**
   * Checks if an object is a `Document`.
   * @see https://dom.spec.whatwg.org/#node
   *
   * @param {any} object the target object
   * @returns {boolean} the query result
   */


  var isDocument = function isDocument(object) {
    return object && object.nodeType === 9 || false;
  };
  /**
   * Returns the `document` or the `#document` element.
   * @see https://github.com/floating-ui/floating-ui
   * @param {(Node | Window)=} node
   * @returns {Document}
   */


  function getDocument(node) {
    // node instanceof Document
    if (isDocument(node)) return node; // node instanceof Node

    if (isNode(node)) return node.ownerDocument; // node instanceof Window

    if (isWindow(node)) return node.document; // node is undefined | NULL

    return window.document;
  }
  /**
   * Utility to check if target is typeof `HTMLElement`, `Element`, `Node`
   * or find one that matches a selector.
   *
   * @param {Node | string} selector the input selector or target element
   * @param {ParentNode=} parent optional node to look into
   * @return {HTMLElement?} the `HTMLElement` or `querySelector` result
   */


  function querySelector(selector, parent) {
    if (isNode(selector)) {
      return selector;
    }

    var lookUp = isNode(parent) ? parent : getDocument();
    return lookUp.querySelector(selector);
  }
  /**
   * Shortcut for `HTMLElement.closest` method which also works
   * with children of `ShadowRoot`. The order of the parameters
   * is intentional since they're both required.
   *
   * @see https://stackoverflow.com/q/54520554/803358
   *
   * @param {HTMLElement} element Element to look into
   * @param {string} selector the selector name
   * @return {HTMLElement?} the query result
   */


  function closest(element, selector) {
    return element ? element.closest(selector) // break out of `ShadowRoot`
    || closest(element.getRootNode().host, selector) : null;
  }
  /**
   * Shortcut for `Object.assign()` static method.
   * @param  {Record<string, any>} obj a target object
   * @param  {Record<string, any>} source a source object
   */


  var ObjectAssign = function ObjectAssign(obj, source) {
    return Object.assign(obj, source);
  };
  /**
   * Check class in `HTMLElement.classList`.
   *
   * @param {HTMLElement} element target
   * @param {string} classNAME to check
   * @returns {boolean}
   */


  function hasClass(element, classNAME) {
    return element.classList.contains(classNAME);
  }
  /**
   * Remove class from `HTMLElement.classList`.
   *
   * @param {HTMLElement} element target
   * @param {string} classNAME to remove
   * @returns {void}
   */


  function removeClass(element, classNAME) {
    element.classList.remove(classNAME);
  }
  /**
   * Checks if an element is an `HTMLElement`.
   * @see https://dom.spec.whatwg.org/#node
   *
   * @param {any} element the target object
   * @returns {boolean} the query result
   */


  var isHTMLElement = function isHTMLElement(element) {
    return element && element.nodeType === 1 || false;
  };
  /** @type {Map<string, Map<HTMLElement, Record<string, any>>>} */


  var componentData = new Map();
  /**
   * An interface for web components background data.
   * @see https://github.com/thednp/bootstrap.native/blob/master/src/components/base-component.js
   */

  var Data = {
    /**
     * Sets web components data.
     * @param {HTMLElement} element target element
     * @param {string} component the component's name or a unique key
     * @param {Record<string, any>} instance the component instance
     */
    set: function set(element, component, instance) {
      if (!isHTMLElement(element)) return;
      /* istanbul ignore else */

      if (!componentData.has(component)) {
        componentData.set(component, new Map());
      }

      var instanceMap = componentData.get(component); // not undefined, but defined right above

      instanceMap.set(element, instance);
    },

    /**
     * Returns all instances for specified component.
     * @param {string} component the component's name or a unique key
     * @returns {Map<HTMLElement, Record<string, any>>?} all the component instances
     */
    getAllFor: function getAllFor(component) {
      var instanceMap = componentData.get(component);
      return instanceMap || null;
    },

    /**
     * Returns the instance associated with the target.
     * @param {HTMLElement} element target element
     * @param {string} component the component's name or a unique key
     * @returns {Record<string, any>?} the instance
     */
    get: function get(element, component) {
      if (!isHTMLElement(element) || !component) return null;
      var allForC = Data.getAllFor(component);
      var instance = element && allForC && allForC.get(element);
      return instance || null;
    },

    /**
     * Removes web components data.
     * @param {HTMLElement} element target element
     * @param {string} component the component's name or a unique key
     */
    remove: function remove(element, component) {
      var instanceMap = componentData.get(component);
      if (!instanceMap || !isHTMLElement(element)) return;
      instanceMap["delete"](element);
      /* istanbul ignore else */

      if (instanceMap.size === 0) {
        componentData["delete"](component);
      }
    }
  };
  /**
   * An alias for `Data.get()`.
   * @type {SHORTY.getInstance<any>}
   */

  var getInstance = function getInstance(target, component) {
    return Data.get(target, component);
  };
  /**
   * Checks if an object is an `Object`.
   *
   * @param {any} obj the target object
   * @returns {boolean} the query result
   */


  var isObject = function isObject(obj) {
    return _typeof(obj) === 'object' || false;
  };
  /**
   * Returns a namespaced `CustomEvent` specific to each component.
   * @param {string} EventType Event.type
   * @param {Record<string, any>=} config Event.options | Event.properties
   * @returns {SHORTY.OriginalEvent} a new namespaced event
   */


  function OriginalEvent(EventType, config) {
    var OriginalCustomEvent = new CustomEvent(EventType, {
      cancelable: true,
      bubbles: true
    });
    /* istanbul ignore else */

    if (isObject(config)) {
      ObjectAssign(OriginalCustomEvent, config);
    }

    return OriginalCustomEvent;
  }
  /**
   * Global namespace for most components `fade` class.
   */


  var fadeClass = 'fade';
  /**
   * Global namespace for most components `show` class.
   */

  var showClass = 'show';
  /**
   * Global namespace for most components `dismiss` option.
   */

  var dataBsDismiss = 'data-bs-dismiss';
  /** @type {string} */

  var alertString = 'alert';
  /** @type {string} */

  var alertComponent = 'Alert';
  /**
   * Shortcut for `HTMLElement.getAttribute()` method.
   * @param {HTMLElement} element target element
   * @param {string} attribute attribute name
   * @returns {string?} attribute value
   */

  var getAttribute = function getAttribute(element, attribute) {
    return element.getAttribute(attribute);
  };
  /**
   * The raw value or a given component option.
   *
   * @typedef {string | HTMLElement | Function | number | boolean | null} niceValue
   */

  /**
   * Utility to normalize component options
   *
   * @param {any} value the input value
   * @return {niceValue} the normalized value
   */


  function normalizeValue(value) {
    if (['true', true].includes(value)) {
      // boolean
      // if ('true' === value) { // boolean
      return true;
    }

    if (['false', false].includes(value)) {
      // boolean
      // if ('false' === value) { // boolean
      return false;
    }

    if (value === '' || value === 'null') {
      // null
      return null;
    }

    if (value !== '' && !Number.isNaN(+value)) {
      // number
      return +value;
    } // string / function / HTMLElement / object


    return value;
  }
  /**
   * Shortcut for `Object.keys()` static method.
   * @param  {Record<string, any>} obj a target object
   * @returns {string[]}
   */


  var ObjectKeys = function ObjectKeys(obj) {
    return Object.keys(obj);
  };
  /**
   * Shortcut for `String.toLowerCase()`.
   *
   * @param {string} source input string
   * @returns {string} lowercase output string
   */


  var toLowerCase = function toLowerCase(source) {
    return source.toLowerCase();
  };
  /**
   * Utility to normalize component options.
   *
   * @param {HTMLElement} element target
   * @param {Record<string, any>} defaultOps component default options
   * @param {Record<string, any>} inputOps component instance options
   * @param {string=} ns component namespace
   * @return {Record<string, any>} normalized component options object
   */


  function normalizeOptions(element, defaultOps, inputOps, ns) {
    var data = _objectSpread({}, element.dataset);
    /** @type {Record<string, any>} */


    var normalOps = {};
    /** @type {Record<string, any>} */

    var dataOps = {};
    var title = 'title';
    ObjectKeys(data).forEach(function (k) {
      var key = ns && k.includes(ns) ? k.replace(ns, '').replace(/[A-Z]/, function (match) {
        return toLowerCase(match);
      }) : k;
      dataOps[key] = normalizeValue(data[k]);
    });
    ObjectKeys(inputOps).forEach(function (k) {
      inputOps[k] = normalizeValue(inputOps[k]);
    });
    ObjectKeys(defaultOps).forEach(function (k) {
      /* istanbul ignore else */
      if (k in inputOps) {
        normalOps[k] = inputOps[k];
      } else if (k in dataOps) {
        normalOps[k] = dataOps[k];
      } else {
        normalOps[k] = k === title ? getAttribute(element, title) : defaultOps[k];
      }
    });
    return normalOps;
  }

  var version = "4.2.0";
  var Version = version;
  /* Native JavaScript for Bootstrap 5 | Base Component
  ----------------------------------------------------- */

  /** Returns a new `BaseComponent` instance. */

  var BaseComponent = /*#__PURE__*/function () {
    /**
     * @param {HTMLElement | string} target `Element` or selector string
     * @param {BSN.ComponentOptions=} config component instance options
     */
    function BaseComponent(target, config) {
      _classCallCheck(this, BaseComponent);

      var self = this;
      var element = querySelector(target);

      if (!element) {
        throw Error("".concat(self.name, " Error: \"").concat(target, "\" is not a valid selector."));
      }
      /** @static @type {BSN.ComponentOptions} */


      self.options = {};
      var prevInstance = Data.get(element, self.name);
      if (prevInstance) prevInstance.dispose();
      /** @type {HTMLElement} */

      self.element = element;
      /* istanbul ignore else */

      if (self.defaults && ObjectKeys(self.defaults).length) {
        self.options = normalizeOptions(element, self.defaults, config || {}, 'bs');
      }

      Data.set(element, self.name, self);
    }
    /* eslint-disable */

    /* istanbul ignore next */

    /** @static */


    _createClass(BaseComponent, [{
      key: "version",
      get: function get() {
        return Version;
      }
      /* eslint-enable */

      /* istanbul ignore next */

      /** @static */

    }, {
      key: "name",
      get: function get() {
        return this.constructor.name;
      }
      /* istanbul ignore next */

      /** @static */

    }, {
      key: "defaults",
      get: function get() {
        return this.constructor.defaults;
      }
      /**
       * Removes component from target element;
       */

    }, {
      key: "dispose",
      value: function dispose() {
        var self = this;
        Data.remove(self.element, self.name);
        ObjectKeys(self).forEach(function (prop) {
          self[prop] = null;
        });
      }
    }]);

    return BaseComponent;
  }();
  /* Native JavaScript for Bootstrap 5 | Alert
  -------------------------------------------- */
  // ALERT PRIVATE GC
  // ================


  var alertSelector = ".".concat(alertString);
  var alertDismissSelector = "[".concat(dataBsDismiss, "=\"").concat(alertString, "\"]");
  /**
   * Static method which returns an existing `Alert` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Alert>}
   */

  var getAlertInstance = function getAlertInstance(element) {
    return getInstance(element, alertComponent);
  };
  /**
  * An `Alert` initialization callback.
  * @type {BSN.InitCallback<Alert>}
  */


  var alertInitCallback = function alertInitCallback(element) {
    return new Alert(element);
  }; // ALERT CUSTOM EVENTS
  // ===================


  var closeAlertEvent = OriginalEvent("close.bs.".concat(alertString));
  var closedAlertEvent = OriginalEvent("closed.bs.".concat(alertString)); // ALERT EVENT HANDLER
  // ===================

  /**
   * Alert `transitionend` callback.
   * @param {Alert} self target Alert instance
   */

  function alertTransitionEnd(self) {
    var element = self.element;
    toggleAlertHandler(self);
    dispatchEvent(element, closedAlertEvent);
    self.dispose();
    element.remove();
  } // ALERT PRIVATE METHOD
  // ====================

  /**
   * Toggle on / off the `click` event listener.
   * @param {Alert} self the target alert instance
   * @param {boolean=} add when `true`, event listener is added
   */


  function toggleAlertHandler(self, add) {
    var action = add ? addListener : removeListener;
    var dismiss = self.dismiss;
    /* istanbul ignore else */

    if (dismiss) action(dismiss, mouseclickEvent, self.close);
  } // ALERT DEFINITION
  // ================

  /** Creates a new Alert instance. */


  var Alert = /*#__PURE__*/function (_BaseComponent) {
    _inherits(Alert, _BaseComponent);

    var _super = _createSuper(Alert);

    /** @param {HTMLElement | string} target element or selector */
    function Alert(target) {
      var _this;

      _classCallCheck(this, Alert);

      _this = _super.call(this, target); // bind

      var self = _assertThisInitialized(_this); // initialization element


      var element = self.element; // the dismiss button

      /** @static @type {HTMLElement?} */

      self.dismiss = querySelector(alertDismissSelector, element); // add event listener

      toggleAlertHandler(self, true);
      return _this;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Alert, [{
      key: "name",
      get: function get() {
        return alertComponent;
      }
      /* eslint-enable */
      // ALERT PUBLIC METHODS
      // ====================

      /**
       * Public method that hides the `.alert` element from the user,
       * disposes the instance once animation is complete, then
       * removes the element from the DOM.
       *
       * @param {Event=} e most likely the `click` event
       * @this {Alert} the `Alert` instance or `EventTarget`
       */

    }, {
      key: "close",
      value: function close(e) {
        var self = e ? getAlertInstance(closest(this, alertSelector)) : this;
        var element = self.element;
        /* istanbul ignore else */

        if (element && hasClass(element, showClass)) {
          dispatchEvent(element, closeAlertEvent);
          if (closeAlertEvent.defaultPrevented) return;
          removeClass(element, showClass);

          if (hasClass(element, fadeClass)) {
            emulateTransitionEnd(element, function () {
              return alertTransitionEnd(self);
            });
          } else alertTransitionEnd(self);
        }
      }
      /** Remove the component from target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        toggleAlertHandler(this);

        _get(_getPrototypeOf(Alert.prototype), "dispose", this).call(this);
      }
    }]);

    return Alert;
  }(BaseComponent);

  ObjectAssign(Alert, {
    selector: alertSelector,
    init: alertInitCallback,
    getInstance: getAlertInstance
  });
  /**
   * A global namespace for aria-pressed.
   * @type {string}
   */

  var ariaPressed = 'aria-pressed';
  /**
   * Shortcut for `HTMLElement.setAttribute()` method.
   * @param  {HTMLElement} element target element
   * @param  {string} attribute attribute name
   * @param  {string} value attribute value
   * @returns {void}
   */

  var setAttribute = function setAttribute(element, attribute, value) {
    return element.setAttribute(attribute, value);
  };
  /**
   * Add class to `HTMLElement.classList`.
   *
   * @param {HTMLElement} element target
   * @param {string} classNAME to add
   * @returns {void}
   */


  function addClass(element, classNAME) {
    element.classList.add(classNAME);
  }
  /**
   * Global namespace for most components active class.
   */


  var activeClass = 'active';
  /**
   * Global namespace for most components `toggle` option.
   */

  var dataBsToggle = 'data-bs-toggle';
  /** @type {string} */

  var buttonString = 'button';
  /** @type {string} */

  var buttonComponent = 'Button';
  /* Native JavaScript for Bootstrap 5 | Button
  ---------------------------------------------*/
  // BUTTON PRIVATE GC
  // =================

  var buttonSelector = "[".concat(dataBsToggle, "=\"").concat(buttonString, "\"]");
  /**
   * Static method which returns an existing `Button` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Button>}
   */

  var getButtonInstance = function getButtonInstance(element) {
    return getInstance(element, buttonComponent);
  };
  /**
   * A `Button` initialization callback.
   * @type {BSN.InitCallback<Button>}
   */


  var buttonInitCallback = function buttonInitCallback(element) {
    return new Button(element);
  }; // BUTTON PRIVATE METHOD
  // =====================

  /**
   * Toggles on/off the `click` event listener.
   * @param {Button} self the `Button` instance
   * @param {boolean=} add when `true`, event listener is added
   */


  function toggleButtonHandler(self, add) {
    var action = add ? addListener : removeListener;
    action(self.element, mouseclickEvent, self.toggle);
  } // BUTTON DEFINITION
  // =================

  /** Creates a new `Button` instance. */


  var Button = /*#__PURE__*/function (_BaseComponent2) {
    _inherits(Button, _BaseComponent2);

    var _super2 = _createSuper(Button);

    /**
     * @param {HTMLElement | string} target usually a `.btn` element
     */
    function Button(target) {
      var _this2;

      _classCallCheck(this, Button);

      _this2 = _super2.call(this, target);

      var self = _assertThisInitialized(_this2); // initialization element


      var element = self.element; // set initial state

      /** @type {boolean} */

      self.isActive = hasClass(element, activeClass);
      setAttribute(element, ariaPressed, "".concat(!!self.isActive)); // add event listener

      toggleButtonHandler(self, true);
      return _this2;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Button, [{
      key: "name",
      get: function get() {
        return buttonComponent;
      }
      /* eslint-enable */
      // BUTTON PUBLIC METHODS
      // =====================

      /**
       * Toggles the state of the target button.
       * @param {MouseEvent} e usually `click` Event object
       */

    }, {
      key: "toggle",
      value: function toggle(e) {
        if (e) e.preventDefault();
        var self = e ? getButtonInstance(this) : this;
        if (!self.element) return;
        var element = self.element,
            isActive = self.isActive;
        if (hasClass(element, 'disabled')) return;
        var action = isActive ? removeClass : addClass;
        action(element, activeClass);
        setAttribute(element, ariaPressed, isActive ? 'false' : 'true');
        self.isActive = hasClass(element, activeClass);
      }
      /** Removes the `Button` component from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        toggleButtonHandler(this);

        _get(_getPrototypeOf(Button.prototype), "dispose", this).call(this);
      }
    }]);

    return Button;
  }(BaseComponent);

  ObjectAssign(Button, {
    selector: buttonSelector,
    init: buttonInitCallback,
    getInstance: getButtonInstance
  });
  /**
   * A global namespace for `mouseenter` event.
   * @type {string}
   */

  var mouseenterEvent = 'mouseenter';
  /**
   * A global namespace for `mouseleave` event.
   * @type {string}
   */

  var mouseleaveEvent = 'mouseleave';
  /**
   * A global namespace for `keydown` event.
   * @type {string}
   */

  var keydownEvent = 'keydown';
  /**
   * A global namespace for `ArrowLeft` key.
   * @type {string} e.which = 37 equivalent
   */

  var keyArrowLeft = 'ArrowLeft';
  /**
   * A global namespace for `ArrowRight` key.
   * @type {string} e.which = 39 equivalent
   */

  var keyArrowRight = 'ArrowRight';
  /**
   * A global namespace for `pointerdown` event.
   * @type {string}
   */

  var pointerdownEvent = 'pointerdown';
  /**
   * A global namespace for `pointermove` event.
   * @type {string}
   */

  var pointermoveEvent = 'pointermove';
  /**
   * A global namespace for `pointerup` event.
   * @type {string}
   */

  var pointerupEvent = 'pointerup';
  /**
   * Returns the bounding client rect of a target `HTMLElement`.
   *
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {HTMLElement} element event.target
   * @param {boolean=} includeScale when *true*, the target scale is also computed
   * @returns {SHORTY.BoundingClientRect} the bounding client rect object
   */

  function getBoundingClientRect(element, includeScale) {
    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height,
        top = _element$getBoundingC.top,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom,
        left = _element$getBoundingC.left;

    var scaleX = 1;
    var scaleY = 1;

    if (includeScale && isHTMLElement(element)) {
      var offsetWidth = element.offsetWidth,
          offsetHeight = element.offsetHeight;
      scaleX = offsetWidth > 0 ? Math.round(width) / offsetWidth :
      /* istanbul ignore next */
      1;
      scaleY = offsetHeight > 0 ? Math.round(height) / offsetHeight :
      /* istanbul ignore next */
      1;
    }

    return {
      width: width / scaleX,
      height: height / scaleY,
      top: top / scaleY,
      right: right / scaleX,
      bottom: bottom / scaleY,
      left: left / scaleX,
      x: left / scaleX,
      y: top / scaleY
    };
  }
  /**
   * Returns the `document.documentElement` or the `<html>` element.
   *
   * @param {(Node | Window)=} node
   * @returns {HTMLHtmlElement}
   */


  function getDocumentElement(node) {
    return getDocument(node).documentElement;
  }
  /**
   * Utility to determine if an `HTMLElement`
   * is partially visible in viewport.
   *
   * @param {HTMLElement} element target
   * @return {boolean} the query result
   */


  var isElementInScrollRange = function isElementInScrollRange(element) {
    if (!element || !isNode(element)) return false;

    var _getBoundingClientRec = getBoundingClientRect(element),
        top = _getBoundingClientRec.top,
        bottom = _getBoundingClientRec.bottom;

    var _getDocumentElement = getDocumentElement(element),
        clientHeight = _getDocumentElement.clientHeight;

    return top <= clientHeight && bottom >= 0;
  };
  /**
   * Checks if a page is Right To Left.
   * @param {HTMLElement=} node the target
   * @returns {boolean} the query result
   */


  var isRTL = function isRTL(node) {
    return getDocumentElement(node).dir === 'rtl';
  };
  /**
   * A shortcut for `(document|Element).querySelectorAll`.
   *
   * @param {string} selector the input selector
   * @param {ParentNode=} parent optional node to look into
   * @return {NodeListOf<HTMLElement>} the query result
   */


  function querySelectorAll(selector, parent) {
    var lookUp = isNode(parent) ? parent : getDocument();
    return lookUp.querySelectorAll(selector);
  }
  /**
   * Shortcut for `HTMLElement.getElementsByClassName` method. Some `Node` elements
   * like `ShadowRoot` do not support `getElementsByClassName`.
   *
   * @param {string} selector the class name
   * @param {ParentNode=} parent optional Element to look into
   * @return {HTMLCollectionOf<HTMLElement>} the 'HTMLCollection'
   */


  function getElementsByClassName(selector, parent) {
    var lookUp = isNode(parent) ? parent : getDocument();
    return lookUp.getElementsByClassName(selector);
  }
  /** @type {Map<HTMLElement, any>} */


  var TimeCache = new Map();
  /**
   * An interface for one or more `TimerHandler`s per `Element`.
   * @see https://github.com/thednp/navbar.js/
   */

  var Timer = {
    /**
     * Sets a new timeout timer for an element, or element -> key association.
     * @param {HTMLElement} element target element
     * @param {ReturnType<TimerHandler>} callback the callback
     * @param {number} delay the execution delay
     * @param {string=} key a unique key
     */
    set: function set(element, callback, delay, key) {
      if (!isHTMLElement(element)) return;
      /* istanbul ignore else */

      if (key && key.length) {
        /* istanbul ignore else */
        if (!TimeCache.has(element)) {
          TimeCache.set(element, new Map());
        }

        var keyTimers = TimeCache.get(element);
        keyTimers.set(key, setTimeout(callback, delay));
      } else {
        TimeCache.set(element, setTimeout(callback, delay));
      }
    },

    /**
     * Returns the timer associated with the target.
     * @param {HTMLElement} element target element
     * @param {string=} key a unique
     * @returns {number?} the timer
     */
    get: function get(element, key) {
      if (!isHTMLElement(element)) return null;
      var keyTimers = TimeCache.get(element);

      if (key && key.length && keyTimers && keyTimers.get) {
        return keyTimers.get(key) ||
        /* istanbul ignore next */
        null;
      }

      return keyTimers || null;
    },

    /**
     * Clears the element's timer.
     * @param {HTMLElement} element target element
     * @param {string=} key a unique key
     */
    clear: function clear(element, key) {
      if (!isHTMLElement(element)) return;

      if (key && key.length) {
        var keyTimers = TimeCache.get(element);
        /* istanbul ignore else */

        if (keyTimers && keyTimers.get) {
          clearTimeout(keyTimers.get(key));
          keyTimers["delete"](key);
          /* istanbul ignore else */

          if (keyTimers.size === 0) {
            TimeCache["delete"](element);
          }
        }
      } else {
        clearTimeout(TimeCache.get(element));
        TimeCache["delete"](element);
      }
    }
  };
  /**
   * Utility to force re-paint of an `HTMLElement` target.
   *
   * @param {HTMLElement} element is the target
   * @return {number} the `Element.offsetHeight` value
   */

  var reflow = function reflow(element) {
    return element.offsetHeight;
  };
  /**
   * A global namespace for most scroll event listeners.
   * @type {Partial<AddEventListenerOptions>}
   */


  var passiveHandler = {
    passive: true
  };
  /**
   * Global namespace for most components `target` option.
   */

  var dataBsTarget = 'data-bs-target';
  /** @type {string} */

  var carouselString = 'carousel';
  /** @type {string} */

  var carouselComponent = 'Carousel';
  /**
   * Global namespace for most components `parent` option.
   */

  var dataBsParent = 'data-bs-parent';
  /**
   * Global namespace for most components `container` option.
   */

  var dataBsContainer = 'data-bs-container';
  /**
   * Returns the `Element` that THIS one targets
   * via `data-bs-target`, `href`, `data-bs-parent` or `data-bs-container`.
   *
   * @param {HTMLElement} element the target element
   * @returns {HTMLElement?} the query result
   */

  function getTargetElement(element) {
    var targetAttr = [dataBsTarget, dataBsParent, dataBsContainer, 'href'];
    var doc = getDocument(element);
    return targetAttr.map(function (att) {
      var attValue = getAttribute(element, att);

      if (attValue) {
        return att === dataBsParent ? closest(element, attValue) : querySelector(attValue, doc);
      }

      return null;
    }).filter(function (x) {
      return x;
    })[0];
  }
  /* Native JavaScript for Bootstrap 5 | Carousel
  ----------------------------------------------- */
  // CAROUSEL PRIVATE GC
  // ===================


  var carouselSelector = "[data-bs-ride=\"".concat(carouselString, "\"]");
  var carouselItem = "".concat(carouselString, "-item");
  var dataBsSlideTo = 'data-bs-slide-to';
  var dataBsSlide = 'data-bs-slide';
  var pausedClass = 'paused';
  var carouselDefaults = {
    pause: 'hover',
    keyboard: false,
    touch: true,
    interval: 5000
  };
  /**
   * Static method which returns an existing `Carousel` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Carousel>}
   */

  var getCarouselInstance = function getCarouselInstance(element) {
    return getInstance(element, carouselComponent);
  };
  /**
   * A `Carousel` initialization callback.
   * @type {BSN.InitCallback<Carousel>}
   */


  var carouselInitCallback = function carouselInitCallback(element) {
    return new Carousel(element);
  };

  var startX = 0;
  var currentX = 0;
  var endX = 0; // CAROUSEL CUSTOM EVENTS
  // ======================

  var carouselSlideEvent = OriginalEvent("slide.bs.".concat(carouselString));
  var carouselSlidEvent = OriginalEvent("slid.bs.".concat(carouselString)); // CAROUSEL EVENT HANDLERS
  // =======================

  /**
   * The `transitionend` event listener of the `Carousel`.
   * @param {Carousel} self the `Carousel` instance
   */

  function carouselTransitionEndHandler(self) {
    var index = self.index,
        direction = self.direction,
        element = self.element,
        slides = self.slides,
        options = self.options; // discontinue disposed instances

    /* istanbul ignore else */

    if (self.isAnimating && getCarouselInstance(element)) {
      var activeItem = getActiveIndex(self);
      var orientation = direction === 'left' ? 'next' : 'prev';
      var directionClass = direction === 'left' ? 'start' : 'end';
      addClass(slides[index], activeClass);
      removeClass(slides[index], "".concat(carouselItem, "-").concat(orientation));
      removeClass(slides[index], "".concat(carouselItem, "-").concat(directionClass));
      removeClass(slides[activeItem], activeClass);
      removeClass(slides[activeItem], "".concat(carouselItem, "-").concat(directionClass));
      dispatchEvent(element, carouselSlidEvent);
      Timer.clear(element, dataBsSlide); // check for element, might have been disposed

      if (!getDocument(element).hidden && options.interval && !self.isPaused) {
        self.cycle();
      }
    }
  }
  /**
   * Handles the `mouseenter` events when *options.pause*
   * is set to `hover`.
   *
   * @this {HTMLElement}
   */


  function carouselPauseHandler() {
    var element = this;
    var self = getCarouselInstance(element);
    /* istanbul ignore else */

    if (self && !self.isPaused && !Timer.get(element, pausedClass)) {
      addClass(element, pausedClass);
    }
  }
  /**
   * Handles the `mouseleave` events when *options.pause*
   * is set to `hover`.
   *
   * @this {HTMLElement}
   */


  function carouselResumeHandler() {
    var element = this;
    var self = getCarouselInstance(element);
    /* istanbul ignore else */

    if (self && self.isPaused && !Timer.get(element, pausedClass)) {
      self.cycle();
    }
  }
  /**
   * Handles the `click` event for the `Carousel` indicators.
   *
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Event` object
   */


  function carouselIndicatorHandler(e) {
    e.preventDefault();
    var indicator = this;
    var element = closest(indicator, carouselSelector) || getTargetElement(indicator);
    var self = getCarouselInstance(element);
    if (!self || self.isAnimating) return;
    var newIndex = +getAttribute(indicator, dataBsSlideTo);

    if (indicator && !hasClass(indicator, activeClass) // event target is not active
    && !Number.isNaN(newIndex)) {
      // AND has the specific attribute
      self.to(newIndex); // do the slide
    }
  }
  /**
   * Handles the `click` event for the `Carousel` arrows.
   *
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Event` object
   */


  function carouselControlsHandler(e) {
    e.preventDefault();
    var control = this;
    var element = closest(control, carouselSelector) || getTargetElement(control);
    var self = getCarouselInstance(element);
    if (!self || self.isAnimating) return;
    var orientation = getAttribute(control, dataBsSlide);
    /* istanbul ignore else */

    if (orientation === 'next') {
      self.next();
    } else if (orientation === 'prev') {
      self.prev();
    }
  }
  /**
   * Handles the keyboard `keydown` event for the visible `Carousel` elements.
   *
   * @param {KeyboardEvent} e the `Event` object
   */


  function carouselKeyHandler(_ref2) {
    var code = _ref2.code,
        target = _ref2.target;
    var doc = getDocument(target);

    var _filter = _toConsumableArray(querySelectorAll(carouselSelector, doc)).filter(function (x) {
      return isElementInScrollRange(x);
    }),
        _filter2 = _slicedToArray(_filter, 1),
        element = _filter2[0];

    var self = getCarouselInstance(element);
    /* istanbul ignore next */

    if (!self || self.isAnimating || /textarea|input/i.test(target.tagName)) return;
    var RTL = isRTL(element);
    var arrowKeyNext = !RTL ? keyArrowRight : keyArrowLeft;
    var arrowKeyPrev = !RTL ? keyArrowLeft : keyArrowRight;
    /* istanbul ignore else */

    if (code === arrowKeyPrev) self.prev();else if (code === arrowKeyNext) self.next();
  } // CAROUSEL TOUCH HANDLERS
  // =======================

  /**
   * Handles the `pointerdown` event for the `Carousel` element.
   *
   * @this {HTMLElement}
   * @param {PointerEvent} e the `Event` object
   */


  function carouselPointerDownHandler(e) {
    var element = this;
    var target = e.target;
    var self = getCarouselInstance(element); // filter pointer event on controls & indicators

    var controls = self.controls,
        indicators = self.indicators;

    if ([].concat(_toConsumableArray(controls), _toConsumableArray(indicators)).some(function (el) {
      return el === target || el.contains(target);
    })) {
      return;
    }

    if (!self || self.isAnimating || self.isTouch) {
      return;
    }

    startX = e.pageX;
    /* istanbul ignore else */

    if (element.contains(target)) {
      self.isTouch = true;
      toggleCarouselTouchHandlers(self, true);
    }
  }
  /**
   * Handles the `pointermove` event for the `Carousel` element.
   *
   * @this {HTMLElement}
   * @param {PointerEvent} e
   */


  function carouselPointerMoveHandler(e) {
    // const self = getCarouselInstance(this);
    // if (!self || !self.isTouch) { return; }
    currentX = e.pageX;
  }
  /**
   * Handles the `pointerup` event for the `Carousel` element.
   *
   * @this {HTMLElement}
    * @param {PointerEvent} e
   */


  function carouselPointerUpHandler(e) {
    var target = e.target;
    var doc = getDocument(target);

    var self = _toConsumableArray(querySelectorAll(carouselSelector, doc)).map(function (c) {
      return getCarouselInstance(c);
    }).find(function (i) {
      return i.isTouch;
    }); // impossible to satisfy

    /* istanbul ignore next */


    if (!self) {
      return;
    }

    var element = self.element,
        index = self.index;
    var RTL = isRTL(target);
    self.isTouch = false;
    toggleCarouselTouchHandlers(self);

    if (doc.getSelection().toString().length) {
      // reset pointer position
      startX = 0;
      currentX = 0;
      endX = 0;
      return;
    }

    endX = e.pageX; // the event target is outside the carousel context
    // OR swipe distance is less than 120px

    /* istanbul ignore else */

    if (!element.contains(target) || Math.abs(startX - endX) < 120) {
      // reset pointer position
      startX = 0;
      currentX = 0;
      endX = 0;
      return;
    } // OR determine next index to slide to

    /* istanbul ignore else */


    if (currentX < startX) {
      self.to(index + (RTL ? -1 : 1));
    } else if (currentX > startX) {
      self.to(index + (RTL ? 1 : -1));
    } // reset pointer position


    startX = 0;
    currentX = 0;
    endX = 0;
  } // CAROUSEL PRIVATE METHODS
  // ========================

  /**
   * Sets active indicator for the `Carousel` instance.
   * @param {Carousel} self the `Carousel` instance
   * @param {number} pageIndex the index of the new active indicator
   */


  function activateCarouselIndicator(self, pageIndex) {
    var indicators = self.indicators;

    _toConsumableArray(indicators).forEach(function (x) {
      return removeClass(x, activeClass);
    });
    /* istanbul ignore else */


    if (self.indicators[pageIndex]) addClass(indicators[pageIndex], activeClass);
  }
  /**
   * Toggles the pointer event listeners for a given `Carousel` instance.
   * @param {Carousel} self the `Carousel` instance
   * @param {boolean=} add when `TRUE` event listeners are added
   */


  function toggleCarouselTouchHandlers(self, add) {
    var element = self.element;
    var action = add ? addListener : removeListener;
    action(getDocument(element), pointermoveEvent, carouselPointerMoveHandler, passiveHandler);
    action(getDocument(element), pointerupEvent, carouselPointerUpHandler, passiveHandler);
  }
  /**
   * Toggles all event listeners for a given `Carousel` instance.
   * @param {Carousel} self the `Carousel` instance
   * @param {boolean=} add when `TRUE` event listeners are added
   */


  function toggleCarouselHandlers(self, add) {
    var element = self.element,
        options = self.options,
        slides = self.slides,
        controls = self.controls,
        indicators = self.indicators;
    var touch = options.touch,
        pause = options.pause,
        interval = options.interval,
        keyboard = options.keyboard;
    var action = add ? addListener : removeListener;

    if (pause && interval) {
      action(element, mouseenterEvent, carouselPauseHandler);
      action(element, mouseleaveEvent, carouselResumeHandler);
    }

    if (touch && slides.length > 2) {
      action(element, pointerdownEvent, carouselPointerDownHandler, passiveHandler);
    }
    /* istanbul ignore else */


    if (controls.length) {
      controls.forEach(function (arrow) {
        /* istanbul ignore else */
        if (arrow) action(arrow, mouseclickEvent, carouselControlsHandler);
      });
    }
    /* istanbul ignore else */


    if (indicators.length) {
      indicators.forEach(function (indicator) {
        action(indicator, mouseclickEvent, carouselIndicatorHandler);
      });
    }

    if (keyboard) action(getDocument(element), keydownEvent, carouselKeyHandler);
  }
  /**
   * Returns the index of the current active item.
   * @param {Carousel} self the `Carousel` instance
   * @returns {number} the query result
   */


  function getActiveIndex(self) {
    var slides = self.slides,
        element = self.element;
    var activeItem = querySelector(".".concat(carouselItem, ".").concat(activeClass), element);
    return _toConsumableArray(slides).indexOf(activeItem);
  } // CAROUSEL DEFINITION
  // ===================

  /** Creates a new `Carousel` instance. */


  var Carousel = /*#__PURE__*/function (_BaseComponent3) {
    _inherits(Carousel, _BaseComponent3);

    var _super3 = _createSuper(Carousel);

    /**
     * @param {HTMLElement | string} target mostly a `.carousel` element
     * @param {BSN.Options.Carousel=} config instance options
     */
    function Carousel(target, config) {
      var _this3;

      _classCallCheck(this, Carousel);

      _this3 = _super3.call(this, target, config); // bind

      var self = _assertThisInitialized(_this3); // initialization element


      var element = self.element; // additional properties

      /** @type {string} */

      self.direction = isRTL(element) ? 'right' : 'left';
      /** @type {number} */

      self.index = 0;
      /** @type {boolean} */

      self.isTouch = false; // carousel elements
      // a LIVE collection is prefferable

      self.slides = getElementsByClassName(carouselItem, element);
      var slides = self.slides; // invalidate when not enough items
      // no need to go further

      if (slides.length < 2) {
        return _possibleConstructorReturn(_this3);
      } // external controls must be within same document context


      var doc = getDocument(element);
      self.controls = [].concat(_toConsumableArray(querySelectorAll("[".concat(dataBsSlide, "]"), element)), _toConsumableArray(querySelectorAll("[".concat(dataBsSlide, "][").concat(dataBsTarget, "=\"#").concat(element.id, "\"]"), doc)));
      /** @type {HTMLElement?} */

      self.indicator = querySelector(".".concat(carouselString, "-indicators"), element); // a LIVE collection is prefferable

      /** @type {HTMLElement[]} */

      self.indicators = [].concat(_toConsumableArray(self.indicator ? querySelectorAll("[".concat(dataBsSlideTo, "]"), self.indicator) : []), _toConsumableArray(querySelectorAll("[".concat(dataBsSlideTo, "][").concat(dataBsTarget, "=\"#").concat(element.id, "\"]"), doc))); // set JavaScript and DATA API options

      var options = self.options; // don't use TRUE as interval, it's actually 0, use the default 5000ms better

      self.options.interval = options.interval === true ? carouselDefaults.interval : options.interval; // set first slide active if none

      /* istanbul ignore else */

      if (getActiveIndex(self) < 0) {
        addClass(slides[0], activeClass);
        /* istanbul ignore else */

        if (self.indicators.length) activateCarouselIndicator(self, 0);
      } // attach event handlers


      toggleCarouselHandlers(self, true); // start to cycle if interval is set

      if (options.interval) self.cycle();
      return _this3;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Carousel, [{
      key: "name",
      get: function get() {
        return carouselComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return carouselDefaults;
      }
      /* eslint-enable */

      /**
       * Check if instance is paused.
       * @returns {boolean}
      */

    }, {
      key: "isPaused",
      get: function get() {
        return hasClass(this.element, pausedClass);
      }
      /**
       * Check if instance is animating.
       * @returns {boolean}
      */

    }, {
      key: "isAnimating",
      get: function get() {
        return querySelector(".".concat(carouselItem, "-next,.").concat(carouselItem, "-prev"), this.element) !== null;
      } // CAROUSEL PUBLIC METHODS
      // =======================

      /** Slide automatically through items. */

    }, {
      key: "cycle",
      value: function cycle() {
        var self = this;
        var element = self.element,
            options = self.options,
            isPaused = self.isPaused,
            index = self.index;
        Timer.clear(element, carouselString);

        if (isPaused) {
          Timer.clear(element, pausedClass);
          removeClass(element, pausedClass);
        }

        Timer.set(element, function () {
          // it's very important to check self.element
          // where instance might have been disposed

          /* istanbul ignore else */
          if (self.element && !self.isPaused && !self.isTouch && isElementInScrollRange(element)) {
            self.to(index + 1);
          }
        }, options.interval, carouselString);
      }
      /** Pause the automatic cycle. */

    }, {
      key: "pause",
      value: function pause() {
        var self = this;
        var element = self.element,
            options = self.options;
        /* istanbul ignore else */

        if (!self.isPaused && options.interval) {
          addClass(element, pausedClass);
          Timer.set(element, function () {}, 1, pausedClass);
        }
      }
      /** Slide to the next item. */

    }, {
      key: "next",
      value: function next() {
        var self = this;
        /* istanbul ignore else */

        if (!self.isAnimating) {
          self.to(self.index + 1);
        }
      }
      /** Slide to the previous item. */

    }, {
      key: "prev",
      value: function prev() {
        var self = this;
        /* istanbul ignore else */

        if (!self.isAnimating) {
          self.to(self.index - 1);
        }
      }
      /**
       * Jump to the item with the `idx` index.
       * @param {number} idx the index of the item to jump to
       */

    }, {
      key: "to",
      value: function to(idx) {
        var self = this;
        var element = self.element,
            slides = self.slides,
            options = self.options;
        var activeItem = getActiveIndex(self);
        var RTL = isRTL(element);
        var next = idx; // when controled via methods, make sure to check again
        // first return if we're on the same item #227
        // `to()` must be SPAM protected by Timer

        if (self.isAnimating || activeItem === next || Timer.get(element, dataBsSlide)) return; // determine transition direction

        /* istanbul ignore else */

        if (activeItem < next || activeItem === 0 && next === slides.length - 1) {
          self.direction = RTL ? 'right' : 'left'; // next
        } else if (activeItem > next || activeItem === slides.length - 1 && next === 0) {
          self.direction = RTL ? 'left' : 'right'; // prev
        }

        var direction = self.direction; // find the right next index

        if (next < 0) {
          next = slides.length - 1;
        } else if (next >= slides.length) {
          next = 0;
        } // orientation, class name, eventProperties


        var orientation = direction === 'left' ? 'next' : 'prev';
        var directionClass = direction === 'left' ? 'start' : 'end';
        var eventProperties = {
          relatedTarget: slides[next],
          from: activeItem,
          to: next,
          direction: direction
        }; // update event properties

        ObjectAssign(carouselSlideEvent, eventProperties);
        ObjectAssign(carouselSlidEvent, eventProperties); // discontinue when prevented

        dispatchEvent(element, carouselSlideEvent);
        if (carouselSlideEvent.defaultPrevented) return; // update index

        self.index = next;
        activateCarouselIndicator(self, next);

        if (getElementTransitionDuration(slides[next]) && hasClass(element, 'slide')) {
          Timer.set(element, function () {
            addClass(slides[next], "".concat(carouselItem, "-").concat(orientation));
            reflow(slides[next]);
            addClass(slides[next], "".concat(carouselItem, "-").concat(directionClass));
            addClass(slides[activeItem], "".concat(carouselItem, "-").concat(directionClass));
            emulateTransitionEnd(slides[next], function () {
              return carouselTransitionEndHandler(self);
            });
          }, 0, dataBsSlide);
        } else {
          addClass(slides[next], activeClass);
          removeClass(slides[activeItem], activeClass);
          Timer.set(element, function () {
            Timer.clear(element, dataBsSlide); // check for element, might have been disposed

            /* istanbul ignore else */

            if (element && options.interval && !self.isPaused) {
              self.cycle();
            }

            dispatchEvent(element, carouselSlidEvent);
          }, 0, dataBsSlide);
        }
      }
      /** Remove `Carousel` component from target. */

    }, {
      key: "dispose",
      value: function dispose() {
        var self = this;
        var slides = self.slides;
        var itemClasses = ['start', 'end', 'prev', 'next'];

        _toConsumableArray(slides).forEach(function (slide, idx) {
          if (hasClass(slide, activeClass)) activateCarouselIndicator(self, idx);
          itemClasses.forEach(function (c) {
            return removeClass(slide, "".concat(carouselItem, "-").concat(c));
          });
        });

        toggleCarouselHandlers(self);

        _get(_getPrototypeOf(Carousel.prototype), "dispose", this).call(this);
      }
    }]);

    return Carousel;
  }(BaseComponent);

  ObjectAssign(Carousel, {
    selector: carouselSelector,
    init: carouselInitCallback,
    getInstance: getCarouselInstance
  });
  /**
   * A global namespace for aria-expanded.
   * @type {string}
   */

  var ariaExpanded = 'aria-expanded';
  /**
   * Shortcut for `Object.entries()` static method.
   * @param  {Record<string, any>} obj a target object
   * @returns {[string, any][]}
   */

  var ObjectEntries = function ObjectEntries(obj) {
    return Object.entries(obj);
  };
  /**
   * Shortcut for multiple uses of `HTMLElement.style.propertyName` method.
   * @param  {HTMLElement} element target element
   * @param  {Partial<CSSStyleDeclaration>} styles attribute value
   */


  var setElementStyle = function setElementStyle(element, styles) {
    ObjectEntries(styles).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      if (key.includes('--')) {
        element.style.setProperty(key, value);
      } else {
        var propObject = {};
        propObject[key] = value;
        ObjectAssign(element.style, propObject);
      }
    });
  };
  /**
   * Global namespace for most components `collapsing` class.
   * As used by `Collapse` / `Tab`.
   */


  var collapsingClass = 'collapsing';
  /** @type {string} */

  var collapseString = 'collapse';
  /** @type {string} */

  var collapseComponent = 'Collapse';
  /* Native JavaScript for Bootstrap 5 | Collapse
  ----------------------------------------------- */
  // COLLAPSE GC
  // ===========

  var collapseSelector = ".".concat(collapseString);
  var collapseToggleSelector = "[".concat(dataBsToggle, "=\"").concat(collapseString, "\"]");
  var collapseDefaults = {
    parent: null
  };
  /**
   * Static method which returns an existing `Collapse` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Collapse>}
   */

  var getCollapseInstance = function getCollapseInstance(element) {
    return getInstance(element, collapseComponent);
  };
  /**
   * A `Collapse` initialization callback.
   * @type {BSN.InitCallback<Collapse>}
   */


  var collapseInitCallback = function collapseInitCallback(element) {
    return new Collapse(element);
  }; // COLLAPSE CUSTOM EVENTS
  // ======================


  var showCollapseEvent = OriginalEvent("show.bs.".concat(collapseString));
  var shownCollapseEvent = OriginalEvent("shown.bs.".concat(collapseString));
  var hideCollapseEvent = OriginalEvent("hide.bs.".concat(collapseString));
  var hiddenCollapseEvent = OriginalEvent("hidden.bs.".concat(collapseString)); // COLLAPSE PRIVATE METHODS
  // ========================

  /**
   * Expand the designated `Element`.
   * @param {Collapse} self the `Collapse` instance
   */

  function expandCollapse(self) {
    var element = self.element,
        parent = self.parent,
        triggers = self.triggers;
    dispatchEvent(element, showCollapseEvent);
    if (showCollapseEvent.defaultPrevented) return;
    Timer.set(element, function () {}, 17);
    if (parent) Timer.set(parent, function () {}, 17);
    addClass(element, collapsingClass);
    removeClass(element, collapseString);
    setElementStyle(element, {
      height: "".concat(element.scrollHeight, "px")
    });
    emulateTransitionEnd(element, function () {
      Timer.clear(element);
      if (parent) Timer.clear(parent);
      triggers.forEach(function (btn) {
        return setAttribute(btn, ariaExpanded, 'true');
      });
      removeClass(element, collapsingClass);
      addClass(element, collapseString);
      addClass(element, showClass);
      setElementStyle(element, {
        height: ''
      });
      dispatchEvent(element, shownCollapseEvent);
    });
  }
  /**
   * Collapse the designated `Element`.
   * @param {Collapse} self the `Collapse` instance
   */


  function collapseContent(self) {
    var element = self.element,
        parent = self.parent,
        triggers = self.triggers;
    dispatchEvent(element, hideCollapseEvent);
    if (hideCollapseEvent.defaultPrevented) return;
    Timer.set(element, function () {}, 17);
    if (parent) Timer.set(parent, function () {}, 17);
    setElementStyle(element, {
      height: "".concat(element.scrollHeight, "px")
    });
    removeClass(element, collapseString);
    removeClass(element, showClass);
    addClass(element, collapsingClass);
    reflow(element);
    setElementStyle(element, {
      height: '0px'
    });
    emulateTransitionEnd(element, function () {
      Timer.clear(element);
      /* istanbul ignore else */

      if (parent) Timer.clear(parent);
      triggers.forEach(function (btn) {
        return setAttribute(btn, ariaExpanded, 'false');
      });
      removeClass(element, collapsingClass);
      addClass(element, collapseString);
      setElementStyle(element, {
        height: ''
      });
      dispatchEvent(element, hiddenCollapseEvent);
    });
  }
  /**
   * Toggles on/off the event listener(s) of the `Collapse` instance.
   * @param {Collapse} self the `Collapse` instance
   * @param {boolean=} add when `true`, the event listener is added
   */


  function toggleCollapseHandler(self, add) {
    var action = add ? addListener : removeListener;
    var triggers = self.triggers;
    /* istanbul ignore else */

    if (triggers.length) {
      triggers.forEach(function (btn) {
        return action(btn, mouseclickEvent, collapseClickHandler);
      });
    }
  } // COLLAPSE EVENT HANDLER
  // ======================

  /**
   * Handles the `click` event for the `Collapse` instance.
   * @param {MouseEvent} e the `Event` object
   */


  function collapseClickHandler(e) {
    var target = e.target; // our target is `HTMLElement`

    var trigger = target && closest(target, collapseToggleSelector);
    var element = trigger && getTargetElement(trigger);
    var self = element && getCollapseInstance(element);
    /* istanbul ignore else */

    if (self) self.toggle(); // event target is anchor link #398

    if (trigger && trigger.tagName === 'A') e.preventDefault();
  } // COLLAPSE DEFINITION
  // ===================

  /** Returns a new `Colapse` instance. */


  var Collapse = /*#__PURE__*/function (_BaseComponent4) {
    _inherits(Collapse, _BaseComponent4);

    var _super4 = _createSuper(Collapse);

    /**
     * @param {HTMLElement | string} target and `Element` that matches the selector
     * @param {BSN.Options.Collapse=} config instance options
     */
    function Collapse(target, config) {
      var _this4;

      _classCallCheck(this, Collapse);

      _this4 = _super4.call(this, target, config); // bind

      var self = _assertThisInitialized(_this4); // initialization element


      var element = self.element,
          options = self.options;
      var doc = getDocument(element); // set triggering elements

      /** @type {HTMLElement[]} */

      self.triggers = _toConsumableArray(querySelectorAll(collapseToggleSelector, doc)).filter(function (btn) {
        return getTargetElement(btn) === element;
      }); // set parent accordion

      /** @type {HTMLElement?} */

      self.parent = querySelector(options.parent, doc) || getTargetElement(element) || null; // add event listeners

      toggleCollapseHandler(self, true);
      return _this4;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Collapse, [{
      key: "name",
      get: function get() {
        return collapseComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return collapseDefaults;
      }
      /* eslint-enable */
      // COLLAPSE PUBLIC METHODS
      // =======================

      /** Toggles the visibility of the collapse. */

    }, {
      key: "toggle",
      value: function toggle() {
        var self = this;
        if (!hasClass(self.element, showClass)) self.show();else self.hide();
      }
      /** Hides the collapse. */

    }, {
      key: "hide",
      value: function hide() {
        var self = this;
        var triggers = self.triggers,
            element = self.element;
        if (Timer.get(element)) return;
        collapseContent(self);
        /* istanbul ignore else */

        if (triggers.length) {
          triggers.forEach(function (btn) {
            return addClass(btn, "".concat(collapseString, "d"));
          });
        }
      }
      /** Shows the collapse. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            parent = self.parent,
            triggers = self.triggers;
        var activeCollapse;
        var activeCollapseInstance;

        if (parent) {
          activeCollapse = _toConsumableArray(querySelectorAll(".".concat(collapseString, ".").concat(showClass), parent)).find(function (i) {
            return getCollapseInstance(i);
          });
          activeCollapseInstance = activeCollapse && getCollapseInstance(activeCollapse);
        }

        if ((!parent || !Timer.get(parent)) && !Timer.get(element)) {
          if (activeCollapseInstance && activeCollapse !== element) {
            collapseContent(activeCollapseInstance);
            activeCollapseInstance.triggers.forEach(function (btn) {
              addClass(btn, "".concat(collapseString, "d"));
            });
          }

          expandCollapse(self);
          /* istanbul ignore else */

          if (triggers.length) {
            triggers.forEach(function (btn) {
              return removeClass(btn, "".concat(collapseString, "d"));
            });
          }
        }
      }
      /** Remove the `Collapse` component from the target `Element`. */

    }, {
      key: "dispose",
      value: function dispose() {
        var self = this;
        toggleCollapseHandler(self);

        _get(_getPrototypeOf(Collapse.prototype), "dispose", this).call(this);
      }
    }]);

    return Collapse;
  }(BaseComponent);

  ObjectAssign(Collapse, {
    selector: collapseSelector,
    init: collapseInitCallback,
    getInstance: getCollapseInstance
  });
  /**
   * A global namespace for `focus` event.
   * @type {string}
   */

  var focusEvent = 'focus';
  /**
   * A global namespace for `keyup` event.
   * @type {string}
   */

  var keyupEvent = 'keyup';
  /**
   * A global namespace for `scroll` event.
   * @type {string}
   */

  var scrollEvent = 'scroll';
  /**
   * A global namespace for `resize` event.
   * @type {string}
   */

  var resizeEvent = 'resize';
  /**
   * A global namespace for `ArrowUp` key.
   * @type {string} e.which = 38 equivalent
   */

  var keyArrowUp = 'ArrowUp';
  /**
   * A global namespace for `ArrowDown` key.
   * @type {string} e.which = 40 equivalent
   */

  var keyArrowDown = 'ArrowDown';
  /**
   * A global namespace for `Escape` key.
   * @type {string} e.which = 27 equivalent
   */

  var keyEscape = 'Escape';
  /**
   * Shortcut for `HTMLElement.hasAttribute()` method.
   * @param  {HTMLElement} element target element
   * @param  {string} attribute attribute name
   * @returns {boolean} the query result
   */

  var hasAttribute = function hasAttribute(element, attribute) {
    return element.hasAttribute(attribute);
  };
  /**
   * Utility to focus an `HTMLElement` target.
   *
   * @param {HTMLElement} element is the target
   */


  var focus = function focus(element) {
    return element.focus();
  };
  /**
   * Returns the `Window` object of a target node.
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {(Node | Window)=} node target node
   * @returns {Window} the `Window` object
   */


  function getWindow(node) {
    // node is undefined | NULL
    if (!node) return window; // node instanceof Document

    if (isDocument(node)) return node.defaultView; // node instanceof Node

    if (isNode(node)) return node.ownerDocument.defaultView; // node is instanceof Window

    return node;
  }
  /**
   * Global namespace for `Dropdown` types / classes.
   */


  var dropdownMenuClasses = ['dropdown', 'dropup', 'dropstart', 'dropend'];
  /** @type {string} */

  var dropdownComponent = 'Dropdown';
  /**
   * Global namespace for `.dropdown-menu`.
   */

  var dropdownMenuClass = 'dropdown-menu';
  /**
   * Checks if an *event.target* or its parent has an `href="#"` value.
   * We need to prevent jumping around onclick, don't we?
   *
   * @param {Node} element the target element
   * @returns {boolean} the query result
   */

  function isEmptyAnchor(element) {
    // `EventTarget` must be `HTMLElement`
    var parentAnchor = closest(element, 'A');
    return isHTMLElement(element) // anchor href starts with #
    && (hasAttribute(element, 'href') && element.href.slice(-1) === '#' // OR a child of an anchor with href starts with #
    || parentAnchor && hasAttribute(parentAnchor, 'href') && parentAnchor.href.slice(-1) === '#');
  }
  /* Native JavaScript for Bootstrap 5 | Dropdown
  ----------------------------------------------- */
  // DROPDOWN PRIVATE GC
  // ===================


  var dropdownString = dropdownMenuClasses[0],
      dropupString = dropdownMenuClasses[1],
      dropstartString = dropdownMenuClasses[2],
      dropendString = dropdownMenuClasses[3];
  var dropdownSelector = "[".concat(dataBsToggle, "=\"").concat(dropdownString, "\"]");
  /**
   * Static method which returns an existing `Dropdown` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Dropdown>}
   */

  var getDropdownInstance = function getDropdownInstance(element) {
    return getInstance(element, dropdownComponent);
  };
  /**
   * A `Dropdown` initialization callback.
   * @type {BSN.InitCallback<Dropdown>}
   */


  var dropdownInitCallback = function dropdownInitCallback(element) {
    return new Dropdown(element);
  }; // DROPDOWN PRIVATE GC
  // ===================
  // const dropdownMenuStartClass = `${dropdownMenuClass}-start`;


  var dropdownMenuEndClass = "".concat(dropdownMenuClass, "-end");
  var verticalClass = [dropdownString, dropupString];
  var horizontalClass = [dropstartString, dropendString];
  var menuFocusTags = ['A', 'BUTTON'];
  var dropdownDefaults = {
    offset: 5,
    // [number] 5(px)
    display: 'dynamic' // [dynamic|static]

  }; // DROPDOWN CUSTOM EVENTS
  // ======================

  var showDropdownEvent = OriginalEvent("show.bs.".concat(dropdownString));
  var shownDropdownEvent = OriginalEvent("shown.bs.".concat(dropdownString));
  var hideDropdownEvent = OriginalEvent("hide.bs.".concat(dropdownString));
  var hiddenDropdownEvent = OriginalEvent("hidden.bs.".concat(dropdownString)); // DROPDOWN PRIVATE METHODS
  // ========================

  /**
   * Apply specific style or class names to a `.dropdown-menu` to automatically
   * accomodate the layout and the page scroll.
   *
   * @param {Dropdown} self the `Dropdown` instance
   */

  function styleDropdown(self) {
    var element = self.element,
        menu = self.menu,
        parentElement = self.parentElement,
        options = self.options;
    var offset = options.offset; // don't apply any style on mobile view

    /* istanbul ignore next: this test requires a navbar */

    if (getElementStyle(menu, 'position') === 'static') return;
    var RTL = isRTL(element); // const menuStart = hasClass(menu, dropdownMenuStartClass);

    var menuEnd = hasClass(menu, dropdownMenuEndClass); // reset menu offset and position

    var resetProps = ['margin', 'top', 'bottom', 'left', 'right'];
    resetProps.forEach(function (p) {
      menu.style[p] = '';
    }); // set initial position class
    // take into account .btn-group parent as .dropdown
    // this requires navbar/btn-group/input-group

    var positionClass = dropdownMenuClasses.find(function (c) {
      return hasClass(parentElement, c);
    }) ||
    /* istanbul ignore next: fallback position */
    dropdownString;
    /** @type {Record<string, Record<string, any>>} */

    var dropdownMargin = {
      dropdown: [offset, 0, 0],
      dropup: [0, 0, offset],
      dropstart: RTL ? [-1, 0, 0, offset] : [-1, offset, 0],
      dropend: RTL ? [-1, offset, 0] : [-1, 0, 0, offset]
    };
    /** @type {Record<string, Record<string, any>>} */

    var dropdownPosition = {
      dropdown: {
        top: '100%'
      },
      dropup: {
        top: 'auto',
        bottom: '100%'
      },
      dropstart: RTL ? {
        left: '100%',
        right: 'auto'
      } : {
        left: 'auto',
        right: '100%'
      },
      dropend: RTL ? {
        left: 'auto',
        right: '100%'
      } : {
        left: '100%',
        right: 'auto'
      },
      menuStart: RTL ? {
        right: 0,
        left: 'auto'
      } : {
        right: 'auto',
        left: 0
      },
      menuEnd: RTL ? {
        right: 'auto',
        left: 0
      } : {
        right: 0,
        left: 'auto'
      }
    };
    var menuWidth = menu.offsetWidth,
        menuHeight = menu.offsetHeight;

    var _getDocumentElement2 = getDocumentElement(element),
        clientWidth = _getDocumentElement2.clientWidth,
        clientHeight = _getDocumentElement2.clientHeight;

    var _getBoundingClientRec2 = getBoundingClientRect(element),
        targetLeft = _getBoundingClientRec2.left,
        targetTop = _getBoundingClientRec2.top,
        targetWidth = _getBoundingClientRec2.width,
        targetHeight = _getBoundingClientRec2.height; // dropstart | dropend


    var leftFullExceed = targetLeft - menuWidth - offset < 0; // dropend

    var rightFullExceed = targetLeft + menuWidth + targetWidth + offset >= clientWidth; // dropstart | dropend

    var bottomExceed = targetTop + menuHeight + offset >= clientHeight; // dropdown

    var bottomFullExceed = targetTop + menuHeight + targetHeight + offset >= clientHeight; // dropup

    var topExceed = targetTop - menuHeight - offset < 0; // dropdown / dropup

    var leftExceed = (!RTL && menuEnd || RTL && !menuEnd) && targetLeft + targetWidth - menuWidth < 0;
    var rightExceed = (RTL && menuEnd || !RTL && !menuEnd) && targetLeft + menuWidth >= clientWidth; // recompute position
    // handle RTL as well

    if (horizontalClass.includes(positionClass) && leftFullExceed && rightFullExceed) {
      positionClass = dropdownString;
    }

    if (positionClass === dropstartString && (!RTL ? leftFullExceed : rightFullExceed)) {
      positionClass = dropendString;
    }

    if (positionClass === dropendString && (RTL ? leftFullExceed : rightFullExceed)) {
      positionClass = dropstartString;
    }

    if (positionClass === dropupString && topExceed && !bottomFullExceed) {
      positionClass = dropdownString;
    }

    if (positionClass === dropdownString && bottomFullExceed && !topExceed) {
      positionClass = dropupString;
    } // override position for horizontal classes


    if (horizontalClass.includes(positionClass) && bottomExceed) {
      ObjectAssign(dropdownPosition[positionClass], {
        top: 'auto',
        bottom: 0
      });
    } // override position for vertical classes


    if (verticalClass.includes(positionClass) && (leftExceed || rightExceed)) {
      // don't realign when menu is wider than window
      // in both RTL and non-RTL readability is KING
      var posAjust;
      if (!leftExceed && rightExceed && !RTL) posAjust = {
        left: 'auto',
        right: 0
      };
      if (leftExceed && !rightExceed && RTL) posAjust = {
        left: 0,
        right: 'auto'
      };
      if (posAjust) ObjectAssign(dropdownPosition[positionClass], posAjust);
    }

    dropdownMargin = dropdownMargin[positionClass];
    setElementStyle(menu, _objectSpread(_objectSpread({}, dropdownPosition[positionClass]), {}, {
      margin: "".concat(dropdownMargin.map(function (x) {
        return x ? "".concat(x, "px") : x;
      }).join(' '))
    })); // override dropdown-menu-start | dropdown-menu-end

    if (verticalClass.includes(positionClass) && menuEnd) {
      /* istanbul ignore else */
      if (menuEnd) {
        var endAdjust = !RTL && leftExceed || RTL && rightExceed ? 'menuStart' :
        /* istanbul ignore next */
        'menuEnd';
        setElementStyle(menu, dropdownPosition[endAdjust]);
      }
    }
  }
  /**
   * Returns an `Array` of focusable items in the given dropdown-menu.
   * @param {HTMLElement} menu
   * @returns {HTMLElement[]}
   */


  function getMenuItems(menu) {
    return _toConsumableArray(menu.children).map(function (c) {
      if (c && menuFocusTags.includes(c.tagName)) return c;
      var firstElementChild = c.firstElementChild;

      if (firstElementChild && menuFocusTags.includes(firstElementChild.tagName)) {
        return firstElementChild;
      }

      return null;
    }).filter(function (c) {
      return c;
    });
  }
  /**
   * Toggles on/off the listeners for the events that close the dropdown
   * as well as event that request a new position for the dropdown.
   *
   * @param {Dropdown} self the `Dropdown` instance
   */


  function toggleDropdownDismiss(self) {
    var element = self.element,
        options = self.options;
    var action = self.open ? addListener : removeListener;
    var doc = getDocument(element);
    action(doc, mouseclickEvent, dropdownDismissHandler);
    action(doc, focusEvent, dropdownDismissHandler);
    action(doc, keydownEvent, dropdownPreventScroll);
    action(doc, keyupEvent, dropdownKeyHandler);
    /* istanbul ignore else */

    if (options.display === 'dynamic') {
      [scrollEvent, resizeEvent].forEach(function (ev) {
        action(getWindow(element), ev, dropdownLayoutHandler, passiveHandler);
      });
    }
  }
  /**
   * Toggles on/off the `click` event listener of the `Dropdown`.
   *
   * @param {Dropdown} self the `Dropdown` instance
   * @param {boolean=} add when `true`, it will add the event listener
   */


  function toggleDropdownHandler(self, add) {
    var action = add ? addListener : removeListener;
    action(self.element, mouseclickEvent, dropdownClickHandler);
  }
  /**
   * Returns the currently open `.dropdown` element.
   *
   * @param {(Node | Window)=} element target
   * @returns {HTMLElement?} the query result
   */


  function getCurrentOpenDropdown(element) {
    var currentParent = [].concat(dropdownMenuClasses, ['btn-group', 'input-group']).map(function (c) {
      return getElementsByClassName("".concat(c, " ").concat(showClass), getDocument(element));
    }).find(function (x) {
      return x.length;
    });

    if (currentParent && currentParent.length) {
      return _toConsumableArray(currentParent[0].children).find(function (x) {
        return hasAttribute(x, dataBsToggle);
      });
    }

    return null;
  } // DROPDOWN EVENT HANDLERS
  // =======================

  /**
   * Handles the `click` event for the `Dropdown` instance.
   *
   * @param {MouseEvent} e event object
   * @this {Document}
   */


  function dropdownDismissHandler(e) {
    var target = e.target,
        type = e.type;
    /* istanbul ignore next: impossible to satisfy */

    if (!target || !target.closest) return; // some weird FF bug #409

    var element = getCurrentOpenDropdown(target);
    var self = getDropdownInstance(element);
    /* istanbul ignore next */

    if (!self) return;
    var parentElement = self.parentElement,
        menu = self.menu;
    var hasData = closest(target, dropdownSelector) !== null;
    var isForm = parentElement && parentElement.contains(target) && (target.tagName === 'form' || closest(target, 'form') !== null);

    if (type === mouseclickEvent && isEmptyAnchor(target)) {
      e.preventDefault();
    }

    if (type === focusEvent && (target === element || target === menu || menu.contains(target))) {
      return;
    }
    /* istanbul ignore else */


    if (isForm || hasData) ;else if (self) {
      self.hide();
    }
  }
  /**
   * Handles `click` event listener for `Dropdown`.
   * @this {HTMLElement}
   * @param {MouseEvent} e event object
   */


  function dropdownClickHandler(e) {
    var element = this;
    var target = e.target;
    var self = getDropdownInstance(element);
    /* istanbul ignore else */

    if (self) {
      self.toggle();
      /* istanbul ignore else */

      if (target && isEmptyAnchor(target)) e.preventDefault();
    }
  }
  /**
   * Prevents scroll when dropdown-menu is visible.
   * @param {KeyboardEvent} e event object
   */


  function dropdownPreventScroll(e) {
    /* istanbul ignore else */
    if ([keyArrowDown, keyArrowUp].includes(e.code)) e.preventDefault();
  }
  /**
   * Handles keyboard `keydown` events for `Dropdown`.
   * @param {KeyboardEvent} e keyboard key
   * @this {Document}
   */


  function dropdownKeyHandler(e) {
    var code = e.code;
    var element = getCurrentOpenDropdown(this);
    var self = element && getDropdownInstance(element);

    var _ref5 = element && getDocument(element),
        activeElement = _ref5.activeElement;
    /* istanbul ignore next: impossible to satisfy */


    if (!self || !activeElement) return;
    var menu = self.menu,
        open = self.open;
    var menuItems = getMenuItems(menu); // arrow up & down

    if (menuItems && menuItems.length && [keyArrowDown, keyArrowUp].includes(code)) {
      var idx = menuItems.indexOf(activeElement);
      /* istanbul ignore else */

      if (activeElement === element) {
        idx = 0;
      } else if (code === keyArrowUp) {
        idx = idx > 1 ? idx - 1 : 0;
      } else if (code === keyArrowDown) {
        idx = idx < menuItems.length - 1 ? idx + 1 : idx;
      }
      /* istanbul ignore else */


      if (menuItems[idx]) focus(menuItems[idx]);
    }

    if (keyEscape === code && open) {
      self.toggle();
      focus(element);
    }
  }
  /**
   * @this {globalThis}
   * @returns {void}
   */


  function dropdownLayoutHandler() {
    var element = getCurrentOpenDropdown(this);
    var self = element && getDropdownInstance(element);
    /* istanbul ignore else */

    if (self && self.open) styleDropdown(self);
  } // DROPDOWN DEFINITION
  // ===================

  /** Returns a new Dropdown instance. */


  var Dropdown = /*#__PURE__*/function (_BaseComponent5) {
    _inherits(Dropdown, _BaseComponent5);

    var _super5 = _createSuper(Dropdown);

    /**
     * @param {HTMLElement | string} target Element or string selector
     * @param {BSN.Options.Dropdown=} config the instance options
     */
    function Dropdown(target, config) {
      var _this5;

      _classCallCheck(this, Dropdown);

      _this5 = _super5.call(this, target, config); // bind

      var self = _assertThisInitialized(_this5); // initialization element


      var element = self.element;
      var parentElement = element.parentElement; // set targets

      /** @type {(Element | HTMLElement)} */

      self.parentElement = parentElement;
      /** @type {(Element | HTMLElement)} */

      self.menu = querySelector(".".concat(dropdownMenuClass), parentElement); // set initial state to closed

      /** @type {boolean} */

      self.open = false; // add event listener

      toggleDropdownHandler(self, true);
      return _this5;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Dropdown, [{
      key: "name",
      get: function get() {
        return dropdownComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return dropdownDefaults;
      }
      /* eslint-enable */
      // DROPDOWN PUBLIC METHODS
      // =======================

      /** Shows/hides the dropdown menu to the user. */

    }, {
      key: "toggle",
      value: function toggle() {
        var self = this;
        if (self.open) self.hide();else self.show();
      }
      /** Shows the dropdown menu to the user. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            open = self.open,
            menu = self.menu,
            parentElement = self.parentElement;
        /* istanbul ignore next */

        if (open) return;
        var currentElement = getCurrentOpenDropdown(element);
        var currentInstance = currentElement && getDropdownInstance(currentElement);
        if (currentInstance) currentInstance.hide(); // dispatch event

        [showDropdownEvent, shownDropdownEvent].forEach(function (e) {
          e.relatedTarget = element;
        });
        dispatchEvent(parentElement, showDropdownEvent);
        if (showDropdownEvent.defaultPrevented) return;
        addClass(menu, showClass);
        addClass(parentElement, showClass);
        setAttribute(element, ariaExpanded, 'true'); // change menu position

        styleDropdown(self);
        self.open = !open;
        focus(element); // focus the element

        toggleDropdownDismiss(self);
        dispatchEvent(parentElement, shownDropdownEvent);
      }
      /** Hides the dropdown menu from the user. */

    }, {
      key: "hide",
      value: function hide() {
        var self = this;
        var element = self.element,
            open = self.open,
            menu = self.menu,
            parentElement = self.parentElement;
        /* istanbul ignore next */

        if (!open) return;
        [hideDropdownEvent, hiddenDropdownEvent].forEach(function (e) {
          e.relatedTarget = element;
        });
        dispatchEvent(parentElement, hideDropdownEvent);
        if (hideDropdownEvent.defaultPrevented) return;
        removeClass(menu, showClass);
        removeClass(parentElement, showClass);
        setAttribute(element, ariaExpanded, 'false');
        self.open = !open; // only re-attach handler if the instance is not disposed

        toggleDropdownDismiss(self);
        dispatchEvent(parentElement, hiddenDropdownEvent);
      }
      /** Removes the `Dropdown` component from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        var self = this;
        if (self.open) self.hide();
        toggleDropdownHandler(self);

        _get(_getPrototypeOf(Dropdown.prototype), "dispose", this).call(this);
      }
    }]);

    return Dropdown;
  }(BaseComponent);

  ObjectAssign(Dropdown, {
    selector: dropdownSelector,
    init: dropdownInitCallback,
    getInstance: getDropdownInstance
  });
  /**
   * A global namespace for aria-hidden.
   * @type {string}
   */

  var ariaHidden = 'aria-hidden';
  /**
   * A global namespace for aria-modal.
   * @type {string}
   */

  var ariaModal = 'aria-modal';
  /**
   * Shortcut for `HTMLElement.removeAttribute()` method.
   * @param  {HTMLElement} element target element
   * @param  {string} attribute attribute name
   * @returns {void}
   */

  var removeAttribute = function removeAttribute(element, attribute) {
    return element.removeAttribute(attribute);
  };
  /**
   * Returns the `document.body` or the `<body>` element.
   *
   * @param {(Node | Window)=} node
   * @returns {HTMLBodyElement}
   */


  function getDocumentBody(node) {
    return getDocument(node).body;
  }
  /** @type {string} */


  var modalString = 'modal';
  /** @type {string} */

  var modalComponent = 'Modal';
  /**
   * Check if target is a `ShadowRoot`.
   *
   * @param {any} element target
   * @returns {boolean} the query result
   */

  var isShadowRoot = function isShadowRoot(element) {
    return element && element.constructor.name === 'ShadowRoot' || false;
  };
  /**
   * Returns the `parentNode` also going through `ShadowRoot`.
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {Node} node the target node
   * @returns {Node} the apropriate parent node
   */


  function getParentNode(node) {
    if (node.nodeName === 'HTML') {
      return node;
    } // this is a quicker (but less type safe) way to save quite some bytes from the bundle


    return node.assignedSlot // step into the shadow DOM of the parent of a slotted node
    || node.parentNode // DOM Element detected
    || isShadowRoot(node) && node.host // ShadowRoot detected
    || getDocumentElement(node) // fallback
    ;
  }
  /**
   * Check if a target element is a `<table>`, `<td>` or `<th>`.
   * This specific check is important for determining
   * the `offsetParent` of a given element.
   *
   * @param {any} element the target element
   * @returns {boolean} the query result
   */


  var isTableElement = function isTableElement(element) {
    return element && ['TABLE', 'TD', 'TH'].includes(element.tagName) || false;
  };
  /**
   * Returns an `HTMLElement` to be used as default value for *options.container*
   * for `Tooltip` / `Popover` components.
   *
   * When `getOffset` is *true*, it returns the `offsetParent` for tooltip/popover
   * offsets computation similar to **floating-ui**.
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {HTMLElement} element the target
   * @param {boolean=} getOffset when *true* it will return an `offsetParent`
   * @returns {ParentNode | Window} the query result
   */


  function getElementContainer(element, getOffset) {
    var majorBlockTags = ['HTML', 'BODY'];

    if (getOffset) {
      /** @type {any} */
      var offsetParent = element.offsetParent;
      var win = getWindow(element);

      while (offsetParent && (isTableElement(offsetParent) || isHTMLElement(offsetParent) // we must count for both fixed & sticky
      && !['sticky', 'fixed'].includes(getElementStyle(offsetParent, 'position')))) {
        offsetParent = offsetParent.offsetParent;
      }

      if (!offsetParent || majorBlockTags.includes(offsetParent.tagName) || getElementStyle(offsetParent, 'position') === 'static') {
        offsetParent = win;
      }

      return offsetParent;
    }
    /** @type {ParentNode[]} */


    var containers = [];
    /** @type {ParentNode} */

    var parentNode = element.parentNode;

    while (parentNode && !majorBlockTags.includes(parentNode.nodeName)) {
      parentNode = getParentNode(parentNode);
      /* istanbul ignore else */

      if (!(isShadowRoot(parentNode) || !!parentNode.shadowRoot || isTableElement(parentNode))) {
        containers.push(parentNode);
      }
    }

    return containers.find(function (c, i) {
      if (getElementStyle(c, 'position') !== 'relative' && containers.slice(i + 1).every(function (r) {
        return getElementStyle(r, 'position') === 'static';
      })) {
        return c;
      }

      return null;
    }) || getDocumentBody(element);
  }
  /**
   * Global namespace for components `fixed-top` class.
   */


  var fixedTopClass = 'fixed-top';
  /**
   * Global namespace for components `fixed-bottom` class.
   */

  var fixedBottomClass = 'fixed-bottom';
  /**
   * Global namespace for components `sticky-top` class.
   */

  var stickyTopClass = 'sticky-top';
  /**
   * Global namespace for components `position-sticky` class.
   */

  var positionStickyClass = 'position-sticky';
  /** @param {(HTMLElement | Document)=} parent */

  var getFixedItems = function getFixedItems(parent) {
    return [].concat(_toConsumableArray(getElementsByClassName(fixedTopClass, parent)), _toConsumableArray(getElementsByClassName(fixedBottomClass, parent)), _toConsumableArray(getElementsByClassName(stickyTopClass, parent)), _toConsumableArray(getElementsByClassName(positionStickyClass, parent)), _toConsumableArray(getElementsByClassName('is-fixed', parent)));
  };
  /**
   * Removes *padding* and *overflow* from the `<body>`
   * and all spacing from fixed items.
   * @param {HTMLElement=} element the target modal/offcanvas
   */


  function resetScrollbar(element) {
    var bd = getDocumentBody(element);
    setElementStyle(bd, {
      paddingRight: '',
      overflow: ''
    });
    var fixedItems = getFixedItems(bd);

    if (fixedItems.length) {
      fixedItems.forEach(function (fixed) {
        setElementStyle(fixed, {
          paddingRight: '',
          marginRight: ''
        });
      });
    }
  }
  /**
   * Returns the scrollbar width if the body does overflow
   * the window.
   * @param {HTMLElement=} element
   * @returns {number} the value
   */


  function measureScrollbar(element) {
    var _getDocumentElement3 = getDocumentElement(element),
        clientWidth = _getDocumentElement3.clientWidth;

    var _getWindow = getWindow(element),
        innerWidth = _getWindow.innerWidth;

    return Math.abs(innerWidth - clientWidth);
  }
  /**
   * Sets the `<body>` and fixed items style when modal / offcanvas
   * is shown to the user.
   *
   * @param {HTMLElement} element the target modal/offcanvas
   * @param {boolean=} overflow body does overflow or not
   */


  function setScrollbar(element, overflow) {
    var bd = getDocumentBody(element);
    var bodyPad = parseInt(getElementStyle(bd, 'paddingRight'), 10);
    var isOpen = getElementStyle(bd, 'overflow') === 'hidden';
    var sbWidth = isOpen && bodyPad ? 0 : measureScrollbar(element);
    var fixedItems = getFixedItems(bd);
    /* istanbul ignore else */

    if (overflow) {
      setElementStyle(bd, {
        overflow: 'hidden',
        paddingRight: "".concat(bodyPad + sbWidth, "px")
      });
      /* istanbul ignore else */

      if (fixedItems.length) {
        fixedItems.forEach(function (fixed) {
          var itemPadValue = getElementStyle(fixed, 'paddingRight');
          fixed.style.paddingRight = "".concat(parseInt(itemPadValue, 10) + sbWidth, "px");
          /* istanbul ignore else */

          if ([stickyTopClass, positionStickyClass].some(function (c) {
            return hasClass(fixed, c);
          })) {
            var itemMValue = getElementStyle(fixed, 'marginRight');
            fixed.style.marginRight = "".concat(parseInt(itemMValue, 10) - sbWidth, "px");
          }
        });
      }
    }
  }
  /**
   * This is a shortie for `document.createElement` method
   * which allows you to create a new `HTMLElement` for a given `tagName`
   * or based on an object with specific non-readonly attributes:
   * `id`, `className`, `textContent`, `style`, etc.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
   *
   * @param {Record<string, string> | string} param `tagName` or object
   * @return {HTMLElement} a new `HTMLElement` or `Element`
   */


  function createElement(param) {
    if (!param) return null;

    if (typeof param === 'string') {
      return getDocument().createElement(param);
    }

    var tagName = param.tagName;

    var attr = _objectSpread({}, param);

    var newElement = createElement(tagName);
    delete attr.tagName;
    ObjectAssign(newElement, attr);
    return newElement;
  }
  /** @type {string} */


  var offcanvasString = 'offcanvas';
  var backdropString = 'backdrop';
  var modalBackdropClass = "".concat(modalString, "-").concat(backdropString);
  var offcanvasBackdropClass = "".concat(offcanvasString, "-").concat(backdropString);
  var modalActiveSelector = ".".concat(modalString, ".").concat(showClass);
  var offcanvasActiveSelector = ".".concat(offcanvasString, ".").concat(showClass); // any document would suffice

  var overlay = createElement('div');
  /**
   * Returns the current active modal / offcancas element.
   * @param {HTMLElement=} element the context element
   * @returns {HTMLElement?} the requested element
   */

  function getCurrentOpen(element) {
    return querySelector("".concat(modalActiveSelector, ",").concat(offcanvasActiveSelector), getDocument(element));
  }
  /**
   * Toogles from a Modal overlay to an Offcanvas, or vice-versa.
   * @param {boolean=} isModal
   */


  function toggleOverlayType(isModal) {
    var targetClass = isModal ? modalBackdropClass : offcanvasBackdropClass;
    [modalBackdropClass, offcanvasBackdropClass].forEach(function (c) {
      removeClass(overlay, c);
    });
    addClass(overlay, targetClass);
  }
  /**
   * Append the overlay to DOM.
   * @param {HTMLElement} container
   * @param {boolean} hasFade
   * @param {boolean=} isModal
   */


  function appendOverlay(container, hasFade, isModal) {
    toggleOverlayType(isModal);
    container.append(overlay);
    if (hasFade) addClass(overlay, fadeClass);
  }
  /**
   * Shows the overlay to the user.
   */


  function showOverlay() {
    if (!hasClass(overlay, showClass)) {
      addClass(overlay, showClass);
      reflow(overlay);
    }
  }
  /**
   * Hides the overlay from the user.
   */


  function hideOverlay() {
    removeClass(overlay, showClass);
  }
  /**
   * Removes the overlay from DOM.
   * @param {HTMLElement=} element
   */


  function removeOverlay(element) {
    if (!getCurrentOpen(element)) {
      removeClass(overlay, fadeClass);
      overlay.remove();
      resetScrollbar(element);
    }
  }
  /**
   * @param {HTMLElement} element target
   * @returns {boolean}
   */


  function isVisible(element) {
    return isHTMLElement(element) && getElementStyle(element, 'visibility') !== 'hidden' && element.offsetParent !== null;
  }
  /* Native JavaScript for Bootstrap 5 | Modal
  -------------------------------------------- */
  // MODAL PRIVATE GC
  // ================


  var modalSelector = ".".concat(modalString);
  var modalToggleSelector = "[".concat(dataBsToggle, "=\"").concat(modalString, "\"]");
  var modalDismissSelector = "[".concat(dataBsDismiss, "=\"").concat(modalString, "\"]");
  var modalStaticClass = "".concat(modalString, "-static");
  var modalDefaults = {
    backdrop: true,
    // boolean|string
    keyboard: true // boolean

  };
  /**
   * Static method which returns an existing `Modal` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Modal>}
   */

  var getModalInstance = function getModalInstance(element) {
    return getInstance(element, modalComponent);
  };
  /**
   * A `Modal` initialization callback.
   * @type {BSN.InitCallback<Modal>}
   */


  var modalInitCallback = function modalInitCallback(element) {
    return new Modal(element);
  }; // MODAL CUSTOM EVENTS
  // ===================


  var showModalEvent = OriginalEvent("show.bs.".concat(modalString));
  var shownModalEvent = OriginalEvent("shown.bs.".concat(modalString));
  var hideModalEvent = OriginalEvent("hide.bs.".concat(modalString));
  var hiddenModalEvent = OriginalEvent("hidden.bs.".concat(modalString)); // MODAL PRIVATE METHODS
  // =====================

  /**
   * Applies special style for the `<body>` and fixed elements
   * when a modal instance is shown to the user.
   *
   * @param {Modal} self the `Modal` instance
   */

  function setModalScrollbar(self) {
    var element = self.element;
    var scrollbarWidth = measureScrollbar(element);

    var _getDocumentElement4 = getDocumentElement(element),
        clientHeight = _getDocumentElement4.clientHeight,
        scrollHeight = _getDocumentElement4.scrollHeight;

    var modalHeight = element.clientHeight,
        modalScrollHeight = element.scrollHeight;
    var modalOverflow = modalHeight !== modalScrollHeight;
    /* istanbul ignore else */

    if (!modalOverflow && scrollbarWidth) {
      var pad = !isRTL(element) ? 'paddingRight' :
      /* istanbul ignore next */
      'paddingLeft';
      var padStyle = {};
      padStyle[pad] = "".concat(scrollbarWidth, "px");
      setElementStyle(element, padStyle);
    }

    setScrollbar(element, modalOverflow || clientHeight !== scrollHeight);
  }
  /**
   * Toggles on/off the listeners of events that close the modal.
   *
   * @param {Modal} self the `Modal` instance
   * @param {boolean=} add when `true`, event listeners are added
   */


  function toggleModalDismiss(self, add) {
    var action = add ? addListener : removeListener;
    var element = self.element;
    action(element, mouseclickEvent, modalDismissHandler);
    action(getWindow(element), resizeEvent, self.update, passiveHandler);
    action(getDocument(element), keydownEvent, modalKeyHandler);
  }
  /**
   * Toggles on/off the `click` event listener of the `Modal` instance.
   * @param {Modal} self the `Modal` instance
   * @param {boolean=} add when `true`, event listener is added
   */


  function toggleModalHandler(self, add) {
    var action = add ? addListener : removeListener;
    var triggers = self.triggers;
    /* istanbul ignore else */

    if (triggers.length) {
      triggers.forEach(function (btn) {
        return action(btn, mouseclickEvent, modalClickHandler);
      });
    }
  }
  /**
   * Executes after a modal is hidden to the user.
   * @param {Modal} self the `Modal` instance
   * @param {Function} callback the `Modal` instance
   */


  function afterModalHide(self, callback) {
    var triggers = self.triggers,
        element = self.element,
        relatedTarget = self.relatedTarget;
    removeOverlay(element);
    setElementStyle(element, {
      paddingRight: '',
      display: ''
    });
    toggleModalDismiss(self);
    var focusElement = showModalEvent.relatedTarget || triggers.find(isVisible);
    /* istanbul ignore else */

    if (focusElement) focus(focusElement);
    /* istanbul ignore else */

    if (callback) callback();
    hiddenModalEvent.relatedTarget = relatedTarget;
    dispatchEvent(element, hiddenModalEvent);
  }
  /**
   * Executes after a modal is shown to the user.
   * @param {Modal} self the `Modal` instance
   */


  function afterModalShow(self) {
    var element = self.element,
        relatedTarget = self.relatedTarget;
    focus(element);
    toggleModalDismiss(self, true);
    shownModalEvent.relatedTarget = relatedTarget;
    dispatchEvent(element, shownModalEvent);
  }
  /**
   * Executes before a modal is shown to the user.
   * @param {Modal} self the `Modal` instance
   */


  function beforeModalShow(self) {
    var element = self.element,
        hasFade = self.hasFade;
    setElementStyle(element, {
      display: 'block'
    });
    setModalScrollbar(self);
    /* istanbul ignore else */

    if (!getCurrentOpen(element)) {
      setElementStyle(getDocumentBody(element), {
        overflow: 'hidden'
      });
    }

    addClass(element, showClass);
    removeAttribute(element, ariaHidden);
    setAttribute(element, ariaModal, 'true');
    if (hasFade) emulateTransitionEnd(element, function () {
      return afterModalShow(self);
    });else afterModalShow(self);
  }
  /**
   * Executes before a modal is hidden to the user.
   * @param {Modal} self the `Modal` instance
   * @param {Function=} callback when `true` skip animation
   */


  function beforeModalHide(self, callback) {
    var element = self.element,
        options = self.options,
        hasFade = self.hasFade; // callback can also be the transitionEvent object, we wanna make sure it's not
    // call is not forced and overlay is visible

    if (options.backdrop && !callback && hasFade && hasClass(overlay, showClass) && !getCurrentOpen(element)) {
      // AND no modal is visible
      hideOverlay();
      emulateTransitionEnd(overlay, function () {
        return afterModalHide(self);
      });
    } else {
      afterModalHide(self, callback);
    }
  } // MODAL EVENT HANDLERS
  // ====================

  /**
   * Handles the `click` event listener for modal.
   * @param {MouseEvent} e the `Event` object
   */


  function modalClickHandler(e) {
    var target = e.target;
    var trigger = target && closest(target, modalToggleSelector);
    var element = trigger && getTargetElement(trigger);
    var self = element && getModalInstance(element);
    /* istanbul ignore else */

    if (trigger && trigger.tagName === 'A') e.preventDefault();
    self.relatedTarget = trigger;
    self.toggle();
  }
  /**
   * Handles the `keydown` event listener for modal
   * to hide the modal when user type the `ESC` key.
   *
   * @param {KeyboardEvent} e the `Event` object
   */


  function modalKeyHandler(_ref6) {
    var code = _ref6.code,
        target = _ref6.target;
    var element = querySelector(modalActiveSelector, getDocument(target));
    var self = element && getModalInstance(element);
    var options = self.options;
    /* istanbul ignore else */

    if (options.keyboard && code === keyEscape // the keyboard option is enabled and the key is 27
    && hasClass(element, showClass)) {
      // the modal is not visible
      self.relatedTarget = null;
      self.hide();
    }
  }
  /**
   * Handles the `click` event listeners that hide the modal.
   *
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Event` object
   */


  function modalDismissHandler(e) {
    var element = this;
    var self = getModalInstance(element); // this timer is needed

    /* istanbul ignore next: must have a filter */

    if (!self || Timer.get(element)) return;
    var options = self.options,
        isStatic = self.isStatic,
        modalDialog = self.modalDialog;
    var backdrop = options.backdrop;
    var target = e.target;
    var selectedText = getDocument(element).getSelection().toString().length;
    var targetInsideDialog = modalDialog.contains(target);
    var dismiss = target && closest(target, modalDismissSelector);
    /* istanbul ignore else */

    if (isStatic && !targetInsideDialog) {
      Timer.set(element, function () {
        addClass(element, modalStaticClass);
        emulateTransitionEnd(modalDialog, function () {
          return staticTransitionEnd(self);
        });
      }, 17);
    } else if (dismiss || !selectedText && !isStatic && !targetInsideDialog && backdrop) {
      self.relatedTarget = dismiss || null;
      self.hide();
      e.preventDefault();
    }
  }
  /**
   * Handles the `transitionend` event listeners for `Modal`.
   *
   * @param {Modal} self the `Modal` instance
   */


  function staticTransitionEnd(self) {
    var element = self.element,
        modalDialog = self.modalDialog;
    var duration = getElementTransitionDuration(modalDialog) + 17;
    removeClass(element, modalStaticClass); // user must wait for zoom out transition

    Timer.set(element, function () {
      return Timer.clear(element);
    }, duration);
  } // MODAL DEFINITION
  // ================

  /** Returns a new `Modal` instance. */


  var Modal = /*#__PURE__*/function (_BaseComponent6) {
    _inherits(Modal, _BaseComponent6);

    var _super6 = _createSuper(Modal);

    /**
     * @param {HTMLElement | string} target usually the `.modal` element
     * @param {BSN.Options.Modal=} config instance options
     */
    function Modal(target, config) {
      var _this6;

      _classCallCheck(this, Modal);

      _this6 = _super6.call(this, target, config); // bind

      var self = _assertThisInitialized(_this6); // the modal


      var element = self.element; // the modal-dialog

      /** @type {(HTMLElement)} */

      self.modalDialog = querySelector(".".concat(modalString, "-dialog"), element); // modal can have multiple triggering elements

      /** @type {HTMLElement[]} */

      self.triggers = _toConsumableArray(querySelectorAll(modalToggleSelector, getDocument(element))).filter(function (btn) {
        return getTargetElement(btn) === element;
      }); // additional internals

      /** @type {boolean} */

      self.isStatic = self.options.backdrop === 'static';
      /** @type {boolean} */

      self.hasFade = hasClass(element, fadeClass);
      /** @type {HTMLElement?} */

      self.relatedTarget = null;
      /** @type {HTMLBodyElement | HTMLElement} */

      self.container = getElementContainer(element); // attach event listeners

      toggleModalHandler(self, true); // bind

      self.update = self.update.bind(self);
      return _this6;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Modal, [{
      key: "name",
      get: function get() {
        return modalComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return modalDefaults;
      }
      /* eslint-enable */
      // MODAL PUBLIC METHODS
      // ====================

      /** Toggles the visibility of the modal. */

    }, {
      key: "toggle",
      value: function toggle() {
        var self = this;
        if (hasClass(self.element, showClass)) self.hide();else self.show();
      }
      /** Shows the modal to the user. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            options = self.options,
            hasFade = self.hasFade,
            relatedTarget = self.relatedTarget,
            container = self.container;
        var backdrop = options.backdrop;
        var overlayDelay = 0;
        if (hasClass(element, showClass)) return;
        showModalEvent.relatedTarget = relatedTarget || null;
        dispatchEvent(element, showModalEvent);
        if (showModalEvent.defaultPrevented) return; // we elegantly hide any opened modal/offcanvas

        var currentOpen = getCurrentOpen(element);

        if (currentOpen && currentOpen !== element) {
          var this1 = getModalInstance(currentOpen);
          var that1 = this1 ||
          /* istanbul ignore next */
          getInstance(currentOpen, 'Offcanvas');
          that1.hide();
        }

        if (backdrop) {
          if (!container.contains(overlay)) {
            appendOverlay(container, hasFade, true);
          } else {
            toggleOverlayType(true);
          }

          overlayDelay = getElementTransitionDuration(overlay);
          showOverlay();
          setTimeout(function () {
            return beforeModalShow(self);
          }, overlayDelay);
        } else {
          beforeModalShow(self);
          /* istanbul ignore else */

          if (currentOpen && hasClass(overlay, showClass)) {
            hideOverlay();
          }
        }
      }
      /**
       * Hide the modal from the user.
       * @param {Function=} callback when defined it will skip animation
       */

    }, {
      key: "hide",
      value: function hide(callback) {
        var self = this;
        var element = self.element,
            hasFade = self.hasFade,
            relatedTarget = self.relatedTarget;
        if (!hasClass(element, showClass)) return;
        hideModalEvent.relatedTarget = relatedTarget || null;
        dispatchEvent(element, hideModalEvent);
        if (hideModalEvent.defaultPrevented) return;
        removeClass(element, showClass);
        setAttribute(element, ariaHidden, 'true');
        removeAttribute(element, ariaModal); // if (hasFade && callback) {

        /* istanbul ignore else */

        if (hasFade) {
          emulateTransitionEnd(element, function () {
            return beforeModalHide(self, callback);
          });
        } else {
          beforeModalHide(self, callback);
        }
      }
      /**
       * Updates the modal layout.
       * @this {Modal} the modal instance
       */

    }, {
      key: "update",
      value: function update() {
        var self = this;
        /* istanbul ignore else */

        if (hasClass(self.element, showClass)) setModalScrollbar(self);
      }
      /** Removes the `Modal` component from target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        var _this7 = this;

        var self = this;
        toggleModalHandler(self); // use callback

        self.hide(function () {
          return _get(_getPrototypeOf(Modal.prototype), "dispose", _this7).call(_this7);
        });
      }
    }]);

    return Modal;
  }(BaseComponent);

  ObjectAssign(Modal, {
    selector: modalSelector,
    init: modalInitCallback,
    getInstance: getModalInstance
  });
  /** @type {string} */

  var offcanvasComponent = 'Offcanvas';
  /* Native JavaScript for Bootstrap 5 | OffCanvas
  ------------------------------------------------ */
  // OFFCANVAS PRIVATE GC
  // ====================

  var offcanvasSelector = ".".concat(offcanvasString);
  var offcanvasToggleSelector = "[".concat(dataBsToggle, "=\"").concat(offcanvasString, "\"]");
  var offcanvasDismissSelector = "[".concat(dataBsDismiss, "=\"").concat(offcanvasString, "\"]");
  var offcanvasTogglingClass = "".concat(offcanvasString, "-toggling");
  var offcanvasDefaults = {
    backdrop: true,
    // boolean
    keyboard: true,
    // boolean
    scroll: false // boolean

  };
  /**
   * Static method which returns an existing `Offcanvas` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Offcanvas>}
   */

  var getOffcanvasInstance = function getOffcanvasInstance(element) {
    return getInstance(element, offcanvasComponent);
  };
  /**
   * An `Offcanvas` initialization callback.
   * @type {BSN.InitCallback<Offcanvas>}
   */


  var offcanvasInitCallback = function offcanvasInitCallback(element) {
    return new Offcanvas(element);
  }; // OFFCANVAS CUSTOM EVENTS
  // =======================


  var showOffcanvasEvent = OriginalEvent("show.bs.".concat(offcanvasString));
  var shownOffcanvasEvent = OriginalEvent("shown.bs.".concat(offcanvasString));
  var hideOffcanvasEvent = OriginalEvent("hide.bs.".concat(offcanvasString));
  var hiddenOffcanvasEvent = OriginalEvent("hidden.bs.".concat(offcanvasString)); // OFFCANVAS PRIVATE METHODS
  // =========================

  /**
   * Sets additional style for the `<body>` and other elements
   * when showing an offcanvas to the user.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   */

  function setOffCanvasScrollbar(self) {
    var element = self.element;

    var _getDocumentElement5 = getDocumentElement(element),
        clientHeight = _getDocumentElement5.clientHeight,
        scrollHeight = _getDocumentElement5.scrollHeight;

    setScrollbar(element, clientHeight !== scrollHeight);
  }
  /**
   * Toggles on/off the `click` event listeners.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   * @param {boolean=} add when *true*, listeners are added
   */


  function toggleOffcanvasEvents(self, add) {
    var action = add ? addListener : removeListener;
    self.triggers.forEach(function (btn) {
      return action(btn, mouseclickEvent, offcanvasTriggerHandler);
    });
  }
  /**
   * Toggles on/off the listeners of the events that close the offcanvas.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   * @param {boolean=} add when *true* listeners are added
   */


  function toggleOffCanvasDismiss(self, add) {
    var action = add ? addListener : removeListener;
    var doc = getDocument(self.element);
    action(doc, keydownEvent, offcanvasKeyDismissHandler);
    action(doc, mouseclickEvent, offcanvasDismissHandler);
  }
  /**
   * Executes before showing the offcanvas.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   */


  function beforeOffcanvasShow(self) {
    var element = self.element,
        options = self.options;
    /* istanbul ignore else */

    if (!options.scroll) {
      setOffCanvasScrollbar(self);
      setElementStyle(getDocumentBody(element), {
        overflow: 'hidden'
      });
    }

    addClass(element, offcanvasTogglingClass);
    addClass(element, showClass);
    setElementStyle(element, {
      visibility: 'visible'
    });
    emulateTransitionEnd(element, function () {
      return showOffcanvasComplete(self);
    });
  }
  /**
   * Executes before hiding the offcanvas.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   * @param {Function=} callback the hide callback
   */


  function beforeOffcanvasHide(self, callback) {
    var element = self.element,
        options = self.options;
    var currentOpen = getCurrentOpen(element);
    element.blur();

    if (!currentOpen && options.backdrop && hasClass(overlay, showClass)) {
      hideOverlay();
      emulateTransitionEnd(overlay, function () {
        return hideOffcanvasComplete(self, callback);
      });
    } else hideOffcanvasComplete(self, callback);
  } // OFFCANVAS EVENT HANDLERS
  // ========================

  /**
   * Handles the `click` event listeners.
   *
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Event` object
   */


  function offcanvasTriggerHandler(e) {
    var trigger = closest(this, offcanvasToggleSelector);
    var element = trigger && getTargetElement(trigger);
    var self = element && getOffcanvasInstance(element);
    /* istanbul ignore else */

    if (self) {
      self.relatedTarget = trigger;
      self.toggle();
      /* istanbul ignore else */

      if (trigger && trigger.tagName === 'A') {
        e.preventDefault();
      }
    }
  }
  /**
   * Handles the event listeners that close the offcanvas.
   *
   * @param {MouseEvent} e the `Event` object
   */


  function offcanvasDismissHandler(e) {
    var target = e.target;
    var element = querySelector(offcanvasActiveSelector, getDocument(target));
    var offCanvasDismiss = querySelector(offcanvasDismissSelector, element);
    var self = getOffcanvasInstance(element);
    /* istanbul ignore next: must have a filter */

    if (!self) return;
    var options = self.options,
        triggers = self.triggers;
    var backdrop = options.backdrop;
    var trigger = closest(target, offcanvasToggleSelector);
    var selection = getDocument(element).getSelection();
    if (overlay.contains(target) && backdrop === 'static') return;
    /* istanbul ignore else */

    if (!(selection && selection.toString().length) && (!element.contains(target) && backdrop && (
    /* istanbul ignore next */
    !trigger || triggers.includes(target)) || offCanvasDismiss && offCanvasDismiss.contains(target))) {
      self.relatedTarget = offCanvasDismiss && offCanvasDismiss.contains(target) ? offCanvasDismiss : null;
      self.hide();
    }
    /* istanbul ignore next */


    if (trigger && trigger.tagName === 'A') e.preventDefault();
  }
  /**
   * Handles the `keydown` event listener for offcanvas
   * to hide it when user type the `ESC` key.
   *
   * @param {KeyboardEvent} e the `Event` object
   */


  function offcanvasKeyDismissHandler(_ref7) {
    var code = _ref7.code,
        target = _ref7.target;
    var element = querySelector(offcanvasActiveSelector, getDocument(target));
    var self = getOffcanvasInstance(element);
    /* istanbul ignore next: must filter */

    if (!self) return;
    /* istanbul ignore else */

    if (self.options.keyboard && code === keyEscape) {
      self.relatedTarget = null;
      self.hide();
    }
  }
  /**
   * Handles the `transitionend` when showing the offcanvas.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   */


  function showOffcanvasComplete(self) {
    var element = self.element;
    removeClass(element, offcanvasTogglingClass);
    removeAttribute(element, ariaHidden);
    setAttribute(element, ariaModal, 'true');
    setAttribute(element, 'role', 'dialog');
    dispatchEvent(element, shownOffcanvasEvent);
    toggleOffCanvasDismiss(self, true);
    focus(element);
  }
  /**
   * Handles the `transitionend` when hiding the offcanvas.
   *
   * @param {Offcanvas} self the `Offcanvas` instance
   * @param {Function} callback the hide callback
   */


  function hideOffcanvasComplete(self, callback) {
    var element = self.element,
        triggers = self.triggers;
    setAttribute(element, ariaHidden, 'true');
    removeAttribute(element, ariaModal);
    removeAttribute(element, 'role');
    setElementStyle(element, {
      visibility: ''
    });
    var visibleTrigger = showOffcanvasEvent.relatedTarget || triggers.find(function (x) {
      return isVisible(x);
    });
    /* istanbul ignore else */

    if (visibleTrigger) focus(visibleTrigger);
    removeOverlay(element);
    dispatchEvent(element, hiddenOffcanvasEvent);
    removeClass(element, offcanvasTogglingClass); // must check for open instances

    if (!getCurrentOpen(element)) {
      toggleOffCanvasDismiss(self);
    } // callback


    if (callback) callback();
  } // OFFCANVAS DEFINITION
  // ====================

  /** Returns a new `Offcanvas` instance. */


  var Offcanvas = /*#__PURE__*/function (_BaseComponent7) {
    _inherits(Offcanvas, _BaseComponent7);

    var _super7 = _createSuper(Offcanvas);

    /**
     * @param {HTMLElement | string} target usually an `.offcanvas` element
     * @param {BSN.Options.Offcanvas=} config instance options
     */
    function Offcanvas(target, config) {
      var _this8;

      _classCallCheck(this, Offcanvas);

      _this8 = _super7.call(this, target, config);

      var self = _assertThisInitialized(_this8); // instance element


      var element = self.element; // all the triggering buttons

      /** @type {HTMLElement[]} */

      self.triggers = _toConsumableArray(querySelectorAll(offcanvasToggleSelector, getDocument(element))).filter(function (btn) {
        return getTargetElement(btn) === element;
      }); // additional instance property

      /** @type {HTMLBodyElement | HTMLElement} */

      self.container = getElementContainer(element);
      /** @type {HTMLElement?} */

      self.relatedTarget = null; // attach event listeners

      toggleOffcanvasEvents(self, true);
      return _this8;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Offcanvas, [{
      key: "name",
      get: function get() {
        return offcanvasComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return offcanvasDefaults;
      }
      /* eslint-enable */
      // OFFCANVAS PUBLIC METHODS
      // ========================

      /** Shows or hides the offcanvas from the user. */

    }, {
      key: "toggle",
      value: function toggle() {
        var self = this;
        if (hasClass(self.element, showClass)) self.hide();else self.show();
      }
      /** Shows the offcanvas to the user. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            options = self.options,
            container = self.container,
            relatedTarget = self.relatedTarget;
        var overlayDelay = 0;
        if (hasClass(element, showClass)) return;
        showOffcanvasEvent.relatedTarget = relatedTarget;
        shownOffcanvasEvent.relatedTarget = relatedTarget;
        dispatchEvent(element, showOffcanvasEvent);
        if (showOffcanvasEvent.defaultPrevented) return; // we elegantly hide any opened modal/offcanvas

        var currentOpen = getCurrentOpen(element);

        if (currentOpen && currentOpen !== element) {
          var this1 = getOffcanvasInstance(currentOpen);
          var that1 = this1 ||
          /* istanbul ignore next */
          getInstance(currentOpen, 'Modal');
          that1.hide();
        }

        if (options.backdrop) {
          if (!container.contains(overlay)) {
            appendOverlay(container, true);
          } else {
            toggleOverlayType();
          }

          overlayDelay = getElementTransitionDuration(overlay);
          showOverlay();
          setTimeout(function () {
            return beforeOffcanvasShow(self);
          }, overlayDelay);
        } else {
          beforeOffcanvasShow(self);
          /* istanbul ignore else */

          if (currentOpen && hasClass(overlay, showClass)) {
            hideOverlay();
          }
        }
      }
      /**
       * Hides the offcanvas from the user.
       * @param {Function=} callback when `true` it will skip animation
       */

    }, {
      key: "hide",
      value: function hide(callback) {
        var self = this;
        var element = self.element,
            relatedTarget = self.relatedTarget;
        if (!hasClass(element, showClass)) return;
        hideOffcanvasEvent.relatedTarget = relatedTarget;
        hiddenOffcanvasEvent.relatedTarget = relatedTarget;
        dispatchEvent(element, hideOffcanvasEvent);
        if (hideOffcanvasEvent.defaultPrevented) return;
        addClass(element, offcanvasTogglingClass);
        removeClass(element, showClass);

        if (!callback) {
          emulateTransitionEnd(element, function () {
            return beforeOffcanvasHide(self, callback);
          });
        } else beforeOffcanvasHide(self, callback);
      }
      /** Removes the `Offcanvas` from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        var _this9 = this;

        var self = this;
        toggleOffcanvasEvents(self);
        self.hide(function () {
          return _get(_getPrototypeOf(Offcanvas.prototype), "dispose", _this9).call(_this9);
        });
      }
    }]);

    return Offcanvas;
  }(BaseComponent);

  ObjectAssign(Offcanvas, {
    selector: offcanvasSelector,
    init: offcanvasInitCallback,
    getInstance: getOffcanvasInstance
  });
  /** @type {string} */

  var popoverString = 'popover';
  /** @type {string} */

  var popoverComponent = 'Popover';
  /** @type {string} */

  var tooltipString = 'tooltip';
  /**
   * Returns a template for Popover / Tooltip.
   *
   * @param {string} tipType the expected markup type
   * @returns {string} the template markup
   */

  function getTipTemplate(tipType) {
    var isTooltip = tipType === tooltipString;
    var bodyClass = isTooltip ? "".concat(tipType, "-inner") : "".concat(tipType, "-body");
    var header = !isTooltip ? "<h3 class=\"".concat(tipType, "-header\"></h3>") : '';
    var arrow = "<div class=\"".concat(tipType, "-arrow\"></div>");
    var body = "<div class=\"".concat(bodyClass, "\"></div>");
    return "<div class=\"".concat(tipType, "\" role=\"").concat(tooltipString, "\">").concat(header + arrow + body, "</div>");
  }
  /**
   * Checks if an element is an `<svg>` (or any type of SVG element),
   * `<img>` or `<video>`.
   *
   * *Tooltip* / *Popover* works different with media elements.
   * @param {any} element the target element
   * @returns {boolean} the query result
   */


  var isMedia = function isMedia(element) {
    return element && element.nodeType === 1 && ['SVG', 'Image', 'Video'].some(function (s) {
      return element.constructor.name.includes(s);
    }) || false;
  };
  /**
   * Returns an `{x,y}` object with the target
   * `HTMLElement` / `Node` scroll position.
   *
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {HTMLElement | Window} element target node / element
   * @returns {{x: number, y: number}} the scroll tuple
   */


  function getNodeScroll(element) {
    var isWin = ('scrollX' in element);
    var x = isWin ? element.scrollX : element.scrollLeft;
    var y = isWin ? element.scrollY : element.scrollTop;
    return {
      x: x,
      y: y
    };
  }
  /**
   * Checks if a target `HTMLElement` is affected by scale.
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {HTMLElement} element target
   * @returns {boolean} the query result
   */


  function isScaledElement(element) {
    if (!element || !isHTMLElement(element)) return false;

    var _getBoundingClientRec3 = getBoundingClientRect(element),
        width = _getBoundingClientRec3.width,
        height = _getBoundingClientRec3.height;

    var offsetWidth = element.offsetWidth,
        offsetHeight = element.offsetHeight;
    return Math.round(width) !== offsetWidth || Math.round(height) !== offsetHeight;
  }
  /**
   * Returns the rect relative to an offset parent.
   * @see https://github.com/floating-ui/floating-ui
   *
   * @param {HTMLElement} element target
   * @param {ParentNode | Window} offsetParent the container / offset parent
   * @param {{x: number, y: number}} scroll the offsetParent scroll position
   * @returns {SHORTY.OffsetRect}
   */


  function getRectRelativeToOffsetParent(element, offsetParent, scroll) {
    var isParentAnElement = isHTMLElement(offsetParent);
    var rect = getBoundingClientRect(element, isParentAnElement && isScaledElement(offsetParent));
    var offsets = {
      x: 0,
      y: 0
    };
    /* istanbul ignore next */

    if (isParentAnElement) {
      var offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }

    return {
      x: rect.left + scroll.x - offsets.x,
      y: rect.top + scroll.y - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }
  /** @type {Record<string, string>} */


  var tipClassPositions = {
    top: 'top',
    bottom: 'bottom',
    left: 'start',
    right: 'end'
  };
  /**
   * Style popovers and tooltips.
   * @param {BSN.Tooltip | BSN.Popover} self the `Popover` / `Tooltip` instance
   * @param {PointerEvent=} e event object
   */

  function styleTip(self, e) {
    var tipClasses = /\b(top|bottom|start|end)+/;
    var element = self.element,
        tooltip = self.tooltip,
        options = self.options,
        arrow = self.arrow,
        offsetParent = self.offsetParent;

    var tipPositions = _objectSpread({}, tipClassPositions);

    var RTL = isRTL(element);

    if (RTL) {
      tipPositions.left = 'end';
      tipPositions.right = 'start';
    } // reset tooltip style (top: 0, left: 0 works best)


    setElementStyle(tooltip, {
      // top: '0px', left: '0px', right: '', bottom: '',
      top: '',
      left: '',
      right: '',
      bottom: ''
    });
    var isPopover = self.name === popoverComponent;
    var tipWidth = tooltip.offsetWidth,
        tipHeight = tooltip.offsetHeight;

    var _getDocumentElement6 = getDocumentElement(element),
        htmlcw = _getDocumentElement6.clientWidth,
        htmlch = _getDocumentElement6.clientHeight;

    var container = options.container;
    var placement = options.placement;

    var _getBoundingClientRec4 = getBoundingClientRect(container, true),
        parentLeft = _getBoundingClientRec4.left,
        parentRight = _getBoundingClientRec4.right,
        parentTop = _getBoundingClientRec4.top;

    var parentCWidth = container.clientWidth,
        parentOWidth = container.offsetWidth;
    var scrollbarWidth = Math.abs(parentCWidth - parentOWidth); // const tipAbsolute = getElementStyle(tooltip, 'position') === 'absolute';

    var parentPosition = getElementStyle(container, 'position'); // const absoluteParent = parentPosition === 'absolute';

    var fixedParent = parentPosition === 'fixed';
    var staticParent = parentPosition === 'static';
    var stickyParent = parentPosition === 'sticky';
    var isSticky = stickyParent && parentTop === parseFloat(getElementStyle(container, 'top')); // const absoluteTarget = getElementStyle(element, 'position') === 'absolute';
    // const stickyFixedParent = ['sticky', 'fixed'].includes(parentPosition);

    var leftBoundry = RTL && fixedParent ? scrollbarWidth : 0;
    var rightBoundry = fixedParent ? parentCWidth + parentLeft + (RTL ? scrollbarWidth : 0) : parentCWidth + parentLeft + (htmlcw - parentRight) - 1;

    var _getBoundingClientRec5 = getBoundingClientRect(element, true),
        elemWidth = _getBoundingClientRec5.width,
        elemHeight = _getBoundingClientRec5.height,
        elemRectLeft = _getBoundingClientRec5.left,
        elemRectRight = _getBoundingClientRec5.right,
        elemRectTop = _getBoundingClientRec5.top;

    var scroll = getNodeScroll(offsetParent);

    var _getRectRelativeToOff = getRectRelativeToOffsetParent(element, offsetParent, scroll),
        x = _getRectRelativeToOff.x,
        y = _getRectRelativeToOff.y; // reset arrow style


    setElementStyle(arrow, {
      top: '',
      left: '',
      right: '',
      bottom: ''
    });
    var topPosition;
    var leftPosition;
    var rightPosition;
    var arrowTop;
    var arrowLeft;
    var arrowRight;
    var arrowWidth = arrow.offsetWidth || 0;
    var arrowHeight = arrow.offsetHeight || 0;
    var arrowAdjust = arrowWidth / 2; // check placement

    var topExceed = elemRectTop - tipHeight - arrowHeight < 0;
    var bottomExceed = elemRectTop + tipHeight + elemHeight + arrowHeight >= htmlch;
    var leftExceed = elemRectLeft - tipWidth - arrowWidth < leftBoundry;
    var rightExceed = elemRectLeft + tipWidth + elemWidth + arrowWidth >= rightBoundry;
    var horizontal = ['left', 'right'];
    var vertical = ['top', 'bottom'];
    topExceed = horizontal.includes(placement) ? elemRectTop + elemHeight / 2 - tipHeight / 2 - arrowHeight < 0 : topExceed;
    bottomExceed = horizontal.includes(placement) ? elemRectTop + tipHeight / 2 + elemHeight / 2 + arrowHeight >= htmlch : bottomExceed;
    leftExceed = vertical.includes(placement) ? elemRectLeft + elemWidth / 2 - tipWidth / 2 < leftBoundry : leftExceed;
    rightExceed = vertical.includes(placement) ? elemRectLeft + tipWidth / 2 + elemWidth / 2 >= rightBoundry : rightExceed; // first remove side positions if both left and right limits are exceeded
    // we usually fall back to top|bottom

    placement = horizontal.includes(placement) && leftExceed && rightExceed ? 'top' : placement; // second, recompute placement

    placement = placement === 'top' && topExceed ? 'bottom' : placement;
    placement = placement === 'bottom' && bottomExceed ? 'top' : placement;
    placement = placement === 'left' && leftExceed ? 'right' : placement;
    placement = placement === 'right' && rightExceed ? 'left' : placement; // update tooltip/popover class

    if (!tooltip.className.includes(placement)) {
      tooltip.className = tooltip.className.replace(tipClasses, tipPositions[placement]);
    } // compute tooltip / popover coordinates

    /* istanbul ignore else */


    if (horizontal.includes(placement)) {
      // secondary|side positions
      if (placement === 'left') {
        // LEFT
        leftPosition = x - tipWidth - (isPopover ? arrowWidth : 0);
      } else {
        // RIGHT
        leftPosition = x + elemWidth + (isPopover ? arrowWidth : 0);
      } // adjust top and arrow


      if (topExceed) {
        topPosition = y;
        topPosition += isSticky ? -parentTop - scroll.y : 0;
        arrowTop = elemHeight / 2 - arrowWidth;
      } else if (bottomExceed) {
        topPosition = y - tipHeight + elemHeight;
        topPosition += isSticky ? -parentTop - scroll.y : 0;
        arrowTop = tipHeight - elemHeight / 2 - arrowWidth;
      } else {
        topPosition = y - tipHeight / 2 + elemHeight / 2;
        topPosition += isSticky ? -parentTop - scroll.y : 0;
        arrowTop = tipHeight / 2 - arrowHeight / 2;
      }
    } else if (vertical.includes(placement)) {
      if (e && isMedia(element)) {
        var eX = 0;
        var eY = 0;

        if (staticParent) {
          eX = e.pageX;
          eY = e.pageY;
        } else {
          // fixedParent | stickyParent
          eX = e.clientX - parentLeft + (fixedParent ? scroll.x : 0);
          eY = e.clientY - parentTop + (fixedParent ? scroll.y : 0);
        } // some weird RTL bug


        eX -= RTL && fixedParent && scrollbarWidth ? scrollbarWidth : 0;

        if (placement === 'top') {
          topPosition = eY - tipHeight - arrowWidth;
        } else {
          topPosition = eY + arrowWidth;
        } // adjust (left | right) and also the arrow


        if (e.clientX - tipWidth / 2 < leftBoundry) {
          leftPosition = 0;
          arrowLeft = eX - arrowAdjust;
        } else if (e.clientX + tipWidth / 2 > rightBoundry) {
          leftPosition = 'auto';
          rightPosition = 0;
          arrowRight = rightBoundry - eX - arrowAdjust;
          arrowRight -= fixedParent ? parentLeft + (RTL ? scrollbarWidth : 0) : 0; // normal top/bottom
        } else {
          leftPosition = eX - tipWidth / 2;
          arrowLeft = tipWidth / 2 - arrowAdjust;
        }
      } else {
        if (placement === 'top') {
          topPosition = y - tipHeight - (isPopover ? arrowHeight : 0);
        } else {
          // BOTTOM
          topPosition = y + elemHeight + (isPopover ? arrowHeight : 0);
        } // adjust left | right and also the arrow


        if (leftExceed) {
          leftPosition = 0;
          arrowLeft = x + elemWidth / 2 - arrowAdjust;
        } else if (rightExceed) {
          leftPosition = 'auto';
          rightPosition = 0;
          arrowRight = elemWidth / 2 + rightBoundry - elemRectRight - arrowAdjust;
        } else {
          leftPosition = x - tipWidth / 2 + elemWidth / 2;
          arrowLeft = tipWidth / 2 - arrowAdjust;
        }
      }
    } // apply style to tooltip/popover


    setElementStyle(tooltip, {
      top: "".concat(topPosition, "px"),
      left: leftPosition === 'auto' ? leftPosition : "".concat(leftPosition, "px"),
      right: rightPosition !== undefined ? "".concat(rightPosition, "px") : ''
    }); // update arrow placement

    /* istanbul ignore else */

    if (isHTMLElement(arrow)) {
      if (arrowTop !== undefined) {
        arrow.style.top = "".concat(arrowTop, "px");
      }

      if (arrowLeft !== undefined) {
        arrow.style.left = "".concat(arrowLeft, "px");
      } else if (arrowRight !== undefined) {
        arrow.style.right = "".concat(arrowRight, "px");
      }
    }
  }

  var tooltipDefaults = {
    /** @type {string} */
    template: getTipTemplate(tooltipString),

    /** @type {string?} */
    title: null,
    // string

    /** @type {string?} */
    customClass: null,
    // string | null

    /** @type {string} */
    trigger: 'hover focus',

    /** @type {string?} */
    placement: 'top',
    // string

    /** @type {((c:string)=>string)?} */
    sanitizeFn: null,
    // function

    /** @type {boolean} */
    animation: true,
    // bool

    /** @type {number} */
    delay: 200,
    // number

    /** @type {HTMLElement?} */
    container: null
  };
  /**
   * A global namespace for aria-describedby.
   * @type {string}
   */

  var ariaDescribedBy = 'aria-describedby';
  /**
   * A global namespace for `mousedown` event.
   * @type {string}
   */

  var mousedownEvent = 'mousedown';
  /**
   * A global namespace for `mousemove` event.
   * @type {string}
   */

  var mousemoveEvent = 'mousemove';
  /**
   * A global namespace for `focusin` event.
   * @type {string}
   */

  var focusinEvent = 'focusin';
  /**
   * A global namespace for `focusout` event.
   * @type {string}
   */

  var focusoutEvent = 'focusout';
  /**
   * A global namespace for `hover` event.
   * @type {string}
   */

  var mousehoverEvent = 'hover';
  /**
   * A global namespace for `touchstart` event.
   * @type {string}
   */

  var touchstartEvent = 'touchstart';
  var elementUID = 0;
  var elementMapUID = 0;
  var elementIDMap = new Map();
  /**
   * Returns a unique identifier for popover, tooltip, scrollspy.
   *
   * @param {HTMLElement} element target element
   * @param {string=} key predefined key
   * @returns {number} an existing or new unique ID
   */

  function getUID(element, key) {
    var result = key ? elementUID : elementMapUID;

    if (key) {
      var elID = getUID(element);
      var elMap = elementIDMap.get(elID) || new Map();

      if (!elementIDMap.has(elID)) {
        elementIDMap.set(elID, elMap);
      }

      if (!elMap.has(key)) {
        elMap.set(key, result);
        elementUID += 1;
      } else result = elMap.get(key);
    } else {
      var elkey = element.id || element;

      if (!elementIDMap.has(elkey)) {
        elementIDMap.set(elkey, result);
        elementMapUID += 1;
      } else result = elementIDMap.get(elkey);
    }

    return result;
  }
  /**
   * Checks if an object is a `Function`.
   *
   * @param {any} fn the target object
   * @returns {boolean} the query result
   */


  var isFunction = function isFunction(fn) {
    return fn && fn.constructor.name === 'Function' || false;
  };

  var _navigator = navigator,
      uaDATA = _navigator.userAgentData;
  /**
   * A global namespace for `userAgentData` object.
   */

  var userAgentData = uaDATA;
  var _navigator2 = navigator,
      userAgentString = _navigator2.userAgent;
  /**
   * A global namespace for `navigator.userAgent` string.
   */

  var userAgent = userAgentString;
  var appleBrands = /(iPhone|iPod|iPad)/;
  /**
   * A global `boolean` for Apple browsers.
   * @type {boolean}
   */

  var isApple = userAgentData ? userAgentData.brands.some(function (x) {
    return appleBrands.test(x.brand);
  }) :
  /* istanbul ignore next */
  appleBrands.test(userAgent);
  /**
   * Global namespace for `data-bs-title` attribute.
   */

  var dataOriginalTitle = 'data-original-title';
  /** @type {string} */

  var tooltipComponent = 'Tooltip';
  /**
   * Checks if an object is a `NodeList`.
   * => equivalent to `object instanceof NodeList`
   *
   * @param {any} object the target object
   * @returns {boolean} the query result
   */

  var isNodeList = function isNodeList(object) {
    return object && object.constructor.name === 'NodeList' || false;
  };
  /**
   * Shortcut for `typeof SOMETHING === "string"`.
   *
   * @param  {any} str input value
   * @returns {boolean} the query result
   */


  var isString = function isString(str) {
    return typeof str === 'string';
  };
  /**
   * Shortcut for `Array.isArray()` static method.
   *
   * @param  {any} arr array-like iterable object
   * @returns {boolean} the query result
   */


  var isArray = function isArray(arr) {
    return Array.isArray(arr);
  };
  /**
   * Append an existing `Element` to Popover / Tooltip component or HTML
   * markup string to be parsed & sanitized to be used as popover / tooltip content.
   *
   * @param {HTMLElement} element target
   * @param {Node | string} content the `Element` to append / string
   * @param {ReturnType<any>} sanitizeFn a function to sanitize string content
   */


  function setHtml(element, content, sanitizeFn) {
    /* istanbul ignore next */
    if (!isHTMLElement(element) || isString(content) && !content.length) return;
    /* istanbul ignore else */

    if (isString(content)) {
      var dirty = content.trim(); // fixing #233

      if (isFunction(sanitizeFn)) dirty = sanitizeFn(dirty);
      var win = getWindow(element);
      var domParser = new win.DOMParser();
      var tempDocument = domParser.parseFromString(dirty, 'text/html');
      element.append.apply(element, _toConsumableArray(tempDocument.body.childNodes));
    } else if (isHTMLElement(content)) {
      element.append(content);
    } else if (isNodeList(content) || isArray(content) && content.every(isNode)) {
      element.append.apply(element, _toConsumableArray(content));
    }
  }
  /**
   * Creates a new tooltip / popover.
   *
   * @param {BSN.Popover | BSN.Tooltip} self the `Tooltip` / `Popover` instance
   */


  function createTip(self) {
    var id = self.id,
        element = self.element,
        options = self.options;
    var animation = options.animation,
        customClass = options.customClass,
        sanitizeFn = options.sanitizeFn,
        placement = options.placement,
        dismissible = options.dismissible,
        title = options.title,
        content = options.content,
        template = options.template,
        btnClose = options.btnClose;
    var isTooltip = self.name === tooltipComponent;
    var tipString = isTooltip ? tooltipString : popoverString;

    var tipPositions = _objectSpread({}, tipClassPositions);

    var titleParts = [];
    var contentParts = [];

    if (isRTL(element)) {
      tipPositions.left = 'end';
      tipPositions.right = 'start';
    } // set initial popover class


    var placementClass = "bs-".concat(tipString, "-").concat(tipPositions[placement]); // load template

    /** @type {HTMLElement?} */

    var tooltipTemplate;

    if (isHTMLElement(template)) {
      tooltipTemplate = template;
    } else {
      var htmlMarkup = createElement('div');
      setHtml(htmlMarkup, template, sanitizeFn);
      tooltipTemplate = htmlMarkup.firstChild;
    } // set popover markup


    self.tooltip = isHTMLElement(tooltipTemplate) && tooltipTemplate.cloneNode(true);
    var tooltip = self.tooltip; // set id and role attributes

    setAttribute(tooltip, 'id', id);
    setAttribute(tooltip, 'role', tooltipString);
    var bodyClass = isTooltip ? "".concat(tooltipString, "-inner") : "".concat(popoverString, "-body");
    var tooltipHeader = isTooltip ? null : querySelector(".".concat(popoverString, "-header"), tooltip);
    var tooltipBody = querySelector(".".concat(bodyClass), tooltip); // set arrow and enable access for styleTip

    self.arrow = querySelector(".".concat(tipString, "-arrow"), tooltip);
    var arrow = self.arrow;
    if (isHTMLElement(title)) titleParts = [title.cloneNode(true)];else {
      var tempTitle = createElement('div');
      setHtml(tempTitle, title, sanitizeFn);
      titleParts = _toConsumableArray(tempTitle.childNodes).concat();
    }
    if (isHTMLElement(content)) contentParts = [content.cloneNode(true)];else {
      var tempContent = createElement('div');
      setHtml(tempContent, content, sanitizeFn);
      contentParts = _toConsumableArray(tempContent.childNodes).concat();
    } // set dismissible button

    if (dismissible) {
      if (title) {
        if (isHTMLElement(btnClose)) titleParts = [].concat(_toConsumableArray(titleParts), [btnClose.cloneNode(true)]);else {
          var tempBtn = createElement('div');
          setHtml(tempBtn, btnClose, sanitizeFn);
          titleParts = [].concat(_toConsumableArray(titleParts), [tempBtn.firstChild]);
        }
      } else {
        /* istanbul ignore else */
        if (tooltipHeader) tooltipHeader.remove();
        if (isHTMLElement(btnClose)) contentParts = [].concat(_toConsumableArray(contentParts), [btnClose.cloneNode(true)]);else {
          var _tempBtn = createElement('div');

          setHtml(_tempBtn, btnClose, sanitizeFn);
          contentParts = [].concat(_toConsumableArray(contentParts), [_tempBtn.firstChild]);
        }
      }
    } // fill the template with content from options / data attributes
    // also sanitize title && content

    /* istanbul ignore else */


    if (!isTooltip) {
      /* istanbul ignore else */
      if (title && tooltipHeader) setHtml(tooltipHeader, titleParts, sanitizeFn);
      /* istanbul ignore else */

      if (content && tooltipBody) setHtml(tooltipBody, contentParts, sanitizeFn); // set btn

      self.btn = querySelector('.btn-close', tooltip);
    } else if (title && tooltipBody) setHtml(tooltipBody, title, sanitizeFn); // Bootstrap 5.2.x


    addClass(tooltip, 'position-absolute');
    addClass(arrow, 'position-absolute'); // set popover animation and placement

    /* istanbul ignore else */

    if (!hasClass(tooltip, tipString)) addClass(tooltip, tipString);
    /* istanbul ignore else */

    if (animation && !hasClass(tooltip, fadeClass)) addClass(tooltip, fadeClass);
    /* istanbul ignore else */

    if (customClass && !hasClass(tooltip, customClass)) {
      // Avast update DS bubbles - allow use of more custom classes
      customClass.split(' ').forEach(function(class) {
        addClass(tooltip, class);
      });
    }
    /* istanbul ignore else */


    if (!hasClass(tooltip, placementClass)) addClass(tooltip, placementClass);
  }
  /**
   * @param {HTMLElement} tip target
   * @param {ParentNode} container parent container
   * @returns {boolean}
   */


  function isVisibleTip(tip, container) {
    return isHTMLElement(tip) && container.contains(tip);
  }
  /* Native JavaScript for Bootstrap 5 | Tooltip
  ---------------------------------------------- */
  // TOOLTIP PRIVATE GC
  // ==================


  var tooltipSelector = "[".concat(dataBsToggle, "=\"").concat(tooltipString, "\"],[data-tip=\"").concat(tooltipString, "\"]");
  var titleAttr = 'title';
  /**
   * Static method which returns an existing `Tooltip` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Tooltip>}
   */

  var getTooltipInstance = function getTooltipInstance(element) {
    return getInstance(element, tooltipComponent);
  };
  /**
   * A `Tooltip` initialization callback.
   * @type {BSN.InitCallback<Tooltip>}
   */


  var tooltipInitCallback = function tooltipInitCallback(element) {
    return new Tooltip(element);
  }; // TOOLTIP PRIVATE METHODS
  // =======================

  /**
   * Removes the tooltip from the DOM.
   *
   * @param {Tooltip} self the `Tooltip` instance
   */


  function removeTooltip(self) {
    var element = self.element,
        tooltip = self.tooltip;
    removeAttribute(element, ariaDescribedBy);
    tooltip.remove();
  }
  /**
   * Executes after the instance has been disposed.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {Function=} callback the parent dispose callback
   */


  function disposeTooltipComplete(self, callback) {
    var element = self.element;
    toggleTooltipHandlers(self);
    /* istanbul ignore else */

    if (hasAttribute(element, dataOriginalTitle) && self.name === tooltipComponent) {
      toggleTooltipTitle(self);
    }
    /* istanbul ignore else */


    if (callback) callback();
  }
  /**
   * Toggles on/off the special `Tooltip` event listeners.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {boolean=} add when `true`, event listeners are added
   */


  function toggleTooltipAction(self, add) {
    var action = add ? addListener : removeListener;
    var element = self.element;
    action(getDocument(element), touchstartEvent, self.handleTouch, passiveHandler);
    /* istanbul ignore else */

    if (!isMedia(element)) {
      [scrollEvent, resizeEvent].forEach(function (ev) {
        action(getWindow(element), ev, self.update, passiveHandler);
      });
    }
  }
  /**
   * Executes after the tooltip was shown to the user.
   *
   * @param {Tooltip} self the `Tooltip` instance
   */


  function tooltipShownAction(self) {
    var element = self.element;
    var shownTooltipEvent = OriginalEvent("shown.bs.".concat(toLowerCase(self.name)));
    toggleTooltipAction(self, true);
    dispatchEvent(element, shownTooltipEvent);
    Timer.clear(element, 'in');
  }
  /**
   * Executes after the tooltip was hidden to the user.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {Function=} callback the dispose callback
   */


  function tooltipHiddenAction(self, callback) {
    var element = self.element;
    var hiddenTooltipEvent = OriginalEvent("hidden.bs.".concat(toLowerCase(self.name)));
    toggleTooltipAction(self);
    removeTooltip(self);
    dispatchEvent(element, hiddenTooltipEvent);
    if (isFunction(callback)) callback();
    Timer.clear(element, 'out');
  }
  /**
   * Toggles on/off the `Tooltip` event listeners.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {boolean=} add when `true`, event listeners are added
   */


  function toggleTooltipHandlers(self, add) {
    var action = add ? addListener : removeListener; // btn is only for dismissible popover

    var element = self.element,
        options = self.options,
        btn = self.btn;
    var trigger = options.trigger,
        dismissible = options.dismissible;
    if (trigger.includes('manual')) return;
    self.enabled = !!add;
    /** @type {string[]} */

    var triggerOptions = trigger.split(' ');
    var elemIsMedia = isMedia(element);

    if (elemIsMedia) {
      action(element, mousemoveEvent, self.update, passiveHandler);
    }

    triggerOptions.forEach(function (tr) {
      /* istanbul ignore else */
      if (elemIsMedia || tr === mousehoverEvent) {
        action(element, mousedownEvent, self.show);
        action(element, mouseenterEvent, self.show);
        /* istanbul ignore else */

        if (dismissible && btn) {
          action(btn, mouseclickEvent, self.hide);
        } else {
          action(element, mouseleaveEvent, self.hide);
          action(getDocument(element), touchstartEvent, self.handleTouch, passiveHandler);
        }
      } else if (tr === mouseclickEvent) {
        action(element, tr, !dismissible ? self.toggle : self.show);
      } else if (tr === focusEvent) {
        action(element, focusinEvent, self.show);
        /* istanbul ignore else */

        if (!dismissible) action(element, focusoutEvent, self.hide);
        /* istanbul ignore else */

        if (isApple) {
          action(element, mouseclickEvent, function () {
            return focus(element);
          });
        }
      }
    });
  }
  /**
   * Toggles on/off the `Tooltip` event listeners that hide/update the tooltip.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {boolean=} add when `true`, event listeners are added
   */


  function toggleTooltipOpenHandlers(self, add) {
    var action = add ? addListener : removeListener;
    var element = self.element,
        options = self.options,
        offsetParent = self.offsetParent;
    var container = options.container;
    var offsetHeight = container.offsetHeight,
        scrollHeight = container.scrollHeight;
    var parentModal = closest(element, ".".concat(modalString));
    var parentOffcanvas = closest(element, ".".concat(offcanvasString));
    /* istanbul ignore else */

    if (!isMedia(element)) {
      var win = getWindow(element);
      var overflow = offsetHeight !== scrollHeight;
      var scrollTarget = overflow || offsetParent !== win ? container : win;
      action(win, resizeEvent, self.update, passiveHandler);
      action(scrollTarget, scrollEvent, self.update, passiveHandler);
    } // dismiss tooltips inside modal / offcanvas


    if (parentModal) action(parentModal, "hide.bs.".concat(modalString), self.hide);
    if (parentOffcanvas) action(parentOffcanvas, "hide.bs.".concat(offcanvasString), self.hide);
  }
  /**
   * Toggles the `title` and `data-original-title` attributes.
   *
   * @param {Tooltip} self the `Tooltip` instance
   * @param {string=} content when `true`, event listeners are added
   */


  function toggleTooltipTitle(self, content) {
    // [0 - add, 1 - remove] | [0 - remove, 1 - add]
    var titleAtt = [dataOriginalTitle, titleAttr];
    var element = self.element;
    setAttribute(element, titleAtt[content ? 0 : 1], content || getAttribute(element, titleAtt[0]));
    removeAttribute(element, titleAtt[content ? 1 : 0]);
  } // TOOLTIP DEFINITION
  // ==================

  /** Creates a new `Tooltip` instance. */


  var Tooltip = /*#__PURE__*/function (_BaseComponent8) {
    _inherits(Tooltip, _BaseComponent8);

    var _super8 = _createSuper(Tooltip);

    /**
     * @param {HTMLElement | string} target the target element
     * @param {BSN.Options.Tooltip=} config the instance options
     */
    function Tooltip(target, config) {
      var _this10;

      _classCallCheck(this, Tooltip);

      _this10 = _super8.call(this, target, config); // bind

      var self = _assertThisInitialized(_this10);

      var element = self.element;
      var isTooltip = self.name === tooltipComponent;
      var tipString = isTooltip ? tooltipString : popoverString;
      var tipComponent = isTooltip ? tooltipComponent : popoverComponent;
      /* istanbul ignore next: this is to set Popover too */

      getTooltipInstance = function getTooltipInstance(elem) {
        return getInstance(elem, tipComponent);
      }; // additional properties

      /** @type {any} */


      self.tooltip = {};

      if (!isTooltip) {
        /** @type {any?} */
        self.btn = null;
      }
      /** @type {any} */


      self.arrow = {};
      /** @type {any} */

      self.offsetParent = {};
      /** @type {boolean} */

      self.enabled = true;
      /** @type {string} Set unique ID for `aria-describedby`. */

      self.id = "".concat(tipString, "-").concat(getUID(element, tipString)); // instance options

      var options = self.options; // invalidate

      if (!options.title && isTooltip || !isTooltip && !options.content) {
        // throw Error(`${this.name} Error: target has no content set.`);
        return _possibleConstructorReturn(_this10);
      }

      var container = querySelector(options.container, getDocument(element));
      var idealContainer = getElementContainer(element); // bypass container option when its position is static/relative

      self.options.container = !container || container && ['static', 'relative'].includes(getElementStyle(container, 'position')) ? idealContainer :
      /* istanbul ignore next */
      container || getDocumentBody(element); // reset default options

      tooltipDefaults[titleAttr] = null; // all functions bind

      self.handleTouch = self.handleTouch.bind(self);
      self.update = self.update.bind(self);
      self.show = self.show.bind(self);
      self.hide = self.hide.bind(self);
      self.toggle = self.toggle.bind(self); // set title attributes and add event listeners

      /* istanbul ignore else */

      if (hasAttribute(element, titleAttr) && isTooltip) {
        toggleTooltipTitle(self, options.title);
      } // create tooltip here


      createTip(self); // attach events

      toggleTooltipHandlers(self, true);
      return _this10;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Tooltip, [{
      key: "name",
      get: function get() {
        return tooltipComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return tooltipDefaults;
      }
      /* eslint-enable */
      // TOOLTIP PUBLIC METHODS
      // ======================

      /**
       * Shows the tooltip.
       *
       * @param {Event=} e the `Event` object
       * @this {Tooltip}
       */

    }, {
      key: "show",
      value: function show(e) {
        var self = this;
        var options = self.options,
            tooltip = self.tooltip,
            element = self.element,
            id = self.id;
        var container = options.container,
            animation = options.animation;
        var outTimer = Timer.get(element, 'out');
        Timer.clear(element, 'out');

        if (tooltip && !outTimer && !isVisibleTip(tooltip, container)) {
          Timer.set(element, function () {
            var showTooltipEvent = OriginalEvent("show.bs.".concat(toLowerCase(self.name)));
            dispatchEvent(element, showTooltipEvent);
            if (showTooltipEvent.defaultPrevented) return; // append to container

            container.append(tooltip);
            setAttribute(element, ariaDescribedBy, "#".concat(id)); // set offsetParent

            self.offsetParent = getElementContainer(tooltip, true);
            self.update(e);
            toggleTooltipOpenHandlers(self, true);
            /* istanbul ignore else */

            if (!hasClass(tooltip, showClass)) addClass(tooltip, showClass);
            /* istanbul ignore else */

            if (animation) emulateTransitionEnd(tooltip, function () {
              return tooltipShownAction(self);
            });else tooltipShownAction(self);
          }, 17, 'in');
        }
      }
      /**
       * Hides the tooltip.
       *
       * @this {Tooltip} the Tooltip instance
       * @param {Function=} callback the dispose callback
       */

    }, {
      key: "hide",
      value: function hide(callback) {
        var self = this;
        var options = self.options,
            tooltip = self.tooltip,
            element = self.element;
        var container = options.container,
            animation = options.animation,
            delay = options.delay;
        Timer.clear(element, 'in');
        /* istanbul ignore else */

        if (tooltip && isVisibleTip(tooltip, container)) {
          Timer.set(element, function () {
            var hideTooltipEvent = OriginalEvent("hide.bs.".concat(toLowerCase(self.name)));
            dispatchEvent(element, hideTooltipEvent);
            if (hideTooltipEvent.defaultPrevented) return;
            removeClass(tooltip, showClass);
            toggleTooltipOpenHandlers(self);
            /* istanbul ignore else */

            if (animation) emulateTransitionEnd(tooltip, function () {
              return tooltipHiddenAction(self, callback);
            });else tooltipHiddenAction(self, callback);
          }, delay + 17, 'out');
        }
      }
      /**
       * Updates the tooltip position.
       *
       * @param {Event=} e the `Event` object
       * @this {Tooltip} the `Tooltip` instance
       */

    }, {
      key: "update",
      value: function update(e) {
        styleTip(this, e);
      }
      /**
       * Toggles the tooltip visibility.
       *
       * @param {Event=} e the `Event` object
       * @this {Tooltip} the instance
       */

    }, {
      key: "toggle",
      value: function toggle(e) {
        var self = this;
        var tooltip = self.tooltip,
            options = self.options;
        if (!isVisibleTip(tooltip, options.container)) self.show(e);else self.hide();
      }
      /** Enables the tooltip. */

    }, {
      key: "enable",
      value: function enable() {
        var self = this;
        var enabled = self.enabled;
        /* istanbul ignore else */

        if (!enabled) {
          toggleTooltipHandlers(self, true);
          self.enabled = !enabled;
        }
      }
      /** Disables the tooltip. */

    }, {
      key: "disable",
      value: function disable() {
        var self = this;
        var tooltip = self.tooltip,
            options = self.options,
            enabled = self.enabled;
        var animation = options.animation,
            container = options.container;
        /* istanbul ignore else */

        if (enabled) {
          if (isVisibleTip(tooltip, container) && animation) {
            self.hide(function () {
              return toggleTooltipHandlers(self);
            });
          } else {
            toggleTooltipHandlers(self);
          }

          self.enabled = !enabled;
        }
      }
      /** Toggles the `disabled` property. */

    }, {
      key: "toggleEnabled",
      value: function toggleEnabled() {
        var self = this;
        if (!self.enabled) self.enable();else self.disable();
      }
      /**
       * Handles the `touchstart` event listener for `Tooltip`
       * @this {Tooltip}
       * @param {TouchEvent} e the `Event` object
       */

    }, {
      key: "handleTouch",
      value: function handleTouch(_ref8) {
        var target = _ref8.target;
        var tooltip = this.tooltip,
            element = this.element;
        /* istanbul ignore next */

        if (tooltip.contains(target) || target === element || target && element.contains(target)) ;else {
          this.hide();
        }
      }
      /** Removes the `Tooltip` from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        var _this11 = this;

        var self = this;
        var tooltip = self.tooltip,
            options = self.options;

        var callback = function callback() {
          return disposeTooltipComplete(self, function () {
            return _get(_getPrototypeOf(Tooltip.prototype), "dispose", _this11).call(_this11);
          });
        };

        if (options.animation && isVisibleTip(tooltip, options.container)) {
          self.options.delay = 0; // reset delay

          self.hide(callback);
        } else {
          callback();
        }
      }
    }]);

    return Tooltip;
  }(BaseComponent);

  ObjectAssign(Tooltip, {
    selector: tooltipSelector,
    init: tooltipInitCallback,
    getInstance: getTooltipInstance,
    styleTip: styleTip
  });
  /* Native JavaScript for Bootstrap 5 | Popover
  ---------------------------------------------- */
  // POPOVER PRIVATE GC
  // ==================

  var popoverSelector = "[".concat(dataBsToggle, "=\"").concat(popoverString, "\"],[data-tip=\"").concat(popoverString, "\"]");

  var popoverDefaults = _objectSpread(_objectSpread({}, tooltipDefaults), {}, {
    /** @type {string} */
    template: getTipTemplate(popoverString),

    /** @type {string} */
    btnClose: '<button class="btn-close" aria-label="Close"></button>',

    /** @type {boolean} */
    dismissible: false,

    /** @type {string?} */
    content: null
  }); // POPOVER DEFINITION
  // ==================

  /** Returns a new `Popover` instance. */


  var Popover = /*#__PURE__*/function (_Tooltip) {
    _inherits(Popover, _Tooltip);

    var _super9 = _createSuper(Popover);

    /* eslint-disable -- we want to specify Popover Options */

    /**
     * @param {HTMLElement | string} target the target element
     * @param {BSN.Options.Popover=} config the instance options
     */
    function Popover(target, config) {
      _classCallCheck(this, Popover);

      return _super9.call(this, target, config);
    }
    /**
     * Returns component name string.
     */


    _createClass(Popover, [{
      key: "name",
      get: function get() {
        return popoverComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return popoverDefaults;
      }
      /* eslint-enable */

      /* extend original `show()` */

    }, {
      key: "show",
      value: function show() {
        _get(_getPrototypeOf(Popover.prototype), "show", this).call(this); // btn only exists within dismissible popover


        var options = this.options,
            btn = this.btn;
        /* istanbul ignore else */

        if (options.dismissible && btn) setTimeout(function () {
          return focus(btn);
        }, 17);
      }
    }]);

    return Popover;
  }(Tooltip);
  /**
   * Static method which returns an existing `Popover` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Popover>}
   */


  var getPopoverInstance = function getPopoverInstance(element) {
    return getInstance(element, popoverComponent);
  };
  /**
   * A `Popover` initialization callback.
   * @type {BSN.InitCallback<Popover>}
   */


  var popoverInitCallback = function popoverInitCallback(element) {
    return new Popover(element);
  };

  ObjectAssign(Popover, {
    selector: popoverSelector,
    init: popoverInitCallback,
    getInstance: getPopoverInstance,
    styleTip: styleTip
  });
  /**
   * Shortcut for `HTMLElement.getElementsByTagName` method. Some `Node` elements
   * like `ShadowRoot` do not support `getElementsByTagName`.
   *
   * @param {string} selector the tag name
   * @param {ParentNode=} parent optional Element to look into
   * @return {HTMLCollectionOf<HTMLElement>} the 'HTMLCollection'
   */

  function getElementsByTagName(selector, parent) {
    var lookUp = isNode(parent) ? parent : getDocument();
    return lookUp.getElementsByTagName(selector);
  }
  /** @type {string} */


  var scrollspyString = 'scrollspy';
  /** @type {string} */

  var scrollspyComponent = 'ScrollSpy';
  /* Native JavaScript for Bootstrap 5 | ScrollSpy
  ------------------------------------------------ */
  // SCROLLSPY PRIVATE GC
  // ====================

  var scrollspySelector = '[data-bs-spy="scroll"]';
  var scrollspyDefaults = {
    offset: 10,
    target: null
  };
  /**
   * Static method which returns an existing `ScrollSpy` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<ScrollSpy>}
   */

  var getScrollSpyInstance = function getScrollSpyInstance(element) {
    return getInstance(element, scrollspyComponent);
  };
  /**
   * A `ScrollSpy` initialization callback.
   * @type {BSN.InitCallback<ScrollSpy>}
   */


  var scrollspyInitCallback = function scrollspyInitCallback(element) {
    return new ScrollSpy(element);
  }; // SCROLLSPY CUSTOM EVENT
  // ======================


  var activateScrollSpy = OriginalEvent("activate.bs.".concat(scrollspyString)); // SCROLLSPY PRIVATE METHODS
  // =========================

  /**
   * Update the state of all items.
   * @param {ScrollSpy} self the `ScrollSpy` instance
   */

  function updateSpyTargets(self) {
    var target = self.target,
        scrollTarget = self.scrollTarget,
        options = self.options,
        itemsLength = self.itemsLength,
        scrollHeight = self.scrollHeight,
        element = self.element;
    var offset = options.offset;
    var isWin = isWindow(scrollTarget);
    var links = target && getElementsByTagName('A', target);
    var scrollHEIGHT = scrollTarget && getScrollHeight(scrollTarget);
    self.scrollTop = isWin ? scrollTarget.scrollY : scrollTarget.scrollTop; // only update items/offsets once or with each mutation

    /* istanbul ignore else */

    if (links && (itemsLength !== links.length || scrollHEIGHT !== scrollHeight)) {
      var href;
      var targetItem;
      var rect; // reset arrays & update

      self.items = [];
      self.offsets = [];
      self.scrollHeight = scrollHEIGHT;
      self.maxScroll = self.scrollHeight - getOffsetHeight(self);

      _toConsumableArray(links).forEach(function (link) {
        href = getAttribute(link, 'href');
        targetItem = href && href.charAt(0) === '#' && href.slice(-1) !== '#' && querySelector(href, getDocument(element));

        if (targetItem) {
          self.items.push(link);
          rect = getBoundingClientRect(targetItem);
          self.offsets.push((isWin ? rect.top + self.scrollTop : targetItem.offsetTop) - offset);
        }
      });

      self.itemsLength = self.items.length;
    }
  }
  /**
   * Returns the `scrollHeight` property of the scrolling element.
   * @param {Node | Window} scrollTarget the `ScrollSpy` instance
   * @return {number} `scrollTarget` height
   */


  function getScrollHeight(scrollTarget) {
    return isHTMLElement(scrollTarget) ? scrollTarget.scrollHeight : getDocumentElement(scrollTarget).scrollHeight;
  }
  /**
   * Returns the height property of the scrolling element.
   * @param {ScrollSpy} params the `ScrollSpy` instance
   * @returns {number}
   */


  function getOffsetHeight(_ref9) {
    var element = _ref9.element,
        scrollTarget = _ref9.scrollTarget;
    return isWindow(scrollTarget) ? scrollTarget.innerHeight : getBoundingClientRect(element).height;
  }
  /**
   * Clear all items of the target.
   * @param {HTMLElement} target a single item
   */


  function clear(target) {
    _toConsumableArray(getElementsByTagName('A', target)).forEach(function (item) {
      if (hasClass(item, activeClass)) removeClass(item, activeClass);
    });
  }
  /**
   * Activates a new item.
   * @param {ScrollSpy} self the `ScrollSpy` instance
   * @param {HTMLElement} item a single item
   */


  function activate(self, item) {
    var target = self.target,
        element = self.element;
    clear(target);
    self.activeItem = item;
    addClass(item, activeClass); // activate all parents

    var parents = [];
    var parentItem = item;

    while (parentItem !== getDocumentBody(element)) {
      parentItem = parentItem.parentElement;
      if (hasClass(parentItem, 'nav') || hasClass(parentItem, 'dropdown-menu')) parents.push(parentItem);
    }

    parents.forEach(function (menuItem) {
      /** @type {HTMLElement?} */
      var parentLink = menuItem.previousElementSibling;
      /* istanbul ignore else */

      if (parentLink && !hasClass(parentLink, activeClass)) {
        addClass(parentLink, activeClass);
      }
    }); // dispatch

    activateScrollSpy.relatedTarget = item;
    dispatchEvent(element, activateScrollSpy);
  }
  /**
   * Toggles on/off the component event listener.
   * @param {ScrollSpy} self the `ScrollSpy` instance
   * @param {boolean=} add when `true`, listener is added
   */


  function toggleSpyHandlers(self, add) {
    var action = add ? addListener : removeListener;
    action(self.scrollTarget, scrollEvent, self.refresh, passiveHandler);
  } // SCROLLSPY DEFINITION
  // ====================

  /** Returns a new `ScrollSpy` instance. */


  var ScrollSpy = /*#__PURE__*/function (_BaseComponent9) {
    _inherits(ScrollSpy, _BaseComponent9);

    var _super10 = _createSuper(ScrollSpy);

    /**
     * @param {HTMLElement | string} target the target element
     * @param {BSN.Options.ScrollSpy=} config the instance options
     */
    function ScrollSpy(target, config) {
      var _this12;

      _classCallCheck(this, ScrollSpy);

      _this12 = _super10.call(this, target, config); // bind

      var self = _assertThisInitialized(_this12); // initialization element & options


      var element = self.element,
          options = self.options; // additional properties

      /** @type {HTMLElement?} */

      self.target = querySelector(options.target, getDocument(element)); // invalidate

      if (!self.target) return _possibleConstructorReturn(_this12); // set initial state

      /** @type {HTMLElement | Window} */

      self.scrollTarget = element.clientHeight < element.scrollHeight ? element : getWindow(element);
      /** @type {number} */

      self.scrollTop = 0;
      /** @type {number} */

      self.maxScroll = 0;
      /** @type {number} */

      self.scrollHeight = 0;
      /** @type {HTMLElement?} */

      self.activeItem = null;
      /** @type {HTMLElement[]} */

      self.items = [];
      /** @type {number} */

      self.itemsLength = 0;
      /** @type {number[]} */

      self.offsets = []; // bind events

      self.refresh = self.refresh.bind(self); // add event handlers

      toggleSpyHandlers(self, true);
      self.refresh();
      return _this12;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(ScrollSpy, [{
      key: "name",
      get: function get() {
        return scrollspyComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return scrollspyDefaults;
      }
      /* eslint-enable */
      // SCROLLSPY PUBLIC METHODS
      // ========================

      /** Updates all items. */

    }, {
      key: "refresh",
      value: function refresh() {
        var self = this;
        var target = self.target; // check if target is visible and invalidate

        /* istanbul ignore next */

        if (target.offsetHeight === 0) return;
        updateSpyTargets(self);
        var scrollTop = self.scrollTop,
            maxScroll = self.maxScroll,
            itemsLength = self.itemsLength,
            items = self.items,
            activeItem = self.activeItem;

        if (scrollTop >= maxScroll) {
          var newActiveItem = items[itemsLength - 1];
          /* istanbul ignore else */

          if (activeItem !== newActiveItem) {
            activate(self, newActiveItem);
          }

          return;
        }

        var offsets = self.offsets;

        if (activeItem && scrollTop < offsets[0] && offsets[0] > 0) {
          self.activeItem = null;
          clear(target);
          return;
        }

        items.forEach(function (item, i) {
          if (activeItem !== item && scrollTop >= offsets[i] && (typeof offsets[i + 1] === 'undefined' || scrollTop < offsets[i + 1])) {
            activate(self, item);
          }
        });
      }
      /** Removes `ScrollSpy` from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        toggleSpyHandlers(this);

        _get(_getPrototypeOf(ScrollSpy.prototype), "dispose", this).call(this);
      }
    }]);

    return ScrollSpy;
  }(BaseComponent);

  ObjectAssign(ScrollSpy, {
    selector: scrollspySelector,
    init: scrollspyInitCallback,
    getInstance: getScrollSpyInstance
  });
  /**
   * A global namespace for aria-selected.
   * @type {string}
   */

  var ariaSelected = 'aria-selected';
  /** @type {string} */

  var tabString = 'tab';
  /** @type {string} */

  var tabComponent = 'Tab';
  /* Native JavaScript for Bootstrap 5 | Tab
  ------------------------------------------ */
  // TAB PRIVATE GC
  // ================

  var tabSelector = "[".concat(dataBsToggle, "=\"").concat(tabString, "\"]");
  /**
   * Static method which returns an existing `Tab` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Tab>}
   */

  var getTabInstance = function getTabInstance(element) {
    return getInstance(element, tabComponent);
  };
  /**
   * A `Tab` initialization callback.
   * @type {BSN.InitCallback<Tab>}
   */


  var tabInitCallback = function tabInitCallback(element) {
    return new Tab(element);
  }; // TAB CUSTOM EVENTS
  // =================


  var showTabEvent = OriginalEvent("show.bs.".concat(tabString));
  var shownTabEvent = OriginalEvent("shown.bs.".concat(tabString));
  var hideTabEvent = OriginalEvent("hide.bs.".concat(tabString));
  var hiddenTabEvent = OriginalEvent("hidden.bs.".concat(tabString));
  /**
   * Stores the current active tab and its content
   * for a given `.nav` element.
   * @type {Map<HTMLElement, any>}
   */

  var tabPrivate = new Map(); // TAB PRIVATE METHODS
  // ===================

  /**
   * Executes after tab transition has finished.
   * @param {Tab} self the `Tab` instance
   */

  function triggerTabEnd(self) {
    var tabContent = self.tabContent,
        nav = self.nav;
    /* istanbul ignore else */

    if (tabContent && hasClass(tabContent, collapsingClass)) {
      tabContent.style.height = '';
      removeClass(tabContent, collapsingClass);
    }
    /* istanbul ignore else */


    if (nav) Timer.clear(nav);
  }
  /**
   * Executes before showing the tab content.
   * @param {Tab} self the `Tab` instance
   */


  function triggerTabShow(self) {
    var element = self.element,
        tabContent = self.tabContent,
        nextContent = self.content,
        nav = self.nav;

    var _ref10 = nav && tabPrivate.get(nav),
        tab = _ref10.tab;
    /* istanbul ignore else */


    if (tabContent && hasClass(nextContent, fadeClass)) {
      var _tabPrivate$get = tabPrivate.get(element),
          currentHeight = _tabPrivate$get.currentHeight,
          nextHeight = _tabPrivate$get.nextHeight;

      if (currentHeight === nextHeight) {
        triggerTabEnd(self);
      } else {
        // enables height animation
        setTimeout(function () {
          tabContent.style.height = "".concat(nextHeight, "px");
          reflow(tabContent);
          emulateTransitionEnd(tabContent, function () {
            return triggerTabEnd(self);
          });
        }, 50);
      }
    } else if (nav) Timer.clear(nav);

    shownTabEvent.relatedTarget = tab;
    dispatchEvent(element, shownTabEvent);
  }
  /**
   * Executes before hiding the tab.
   * @param {Tab} self the `Tab` instance
   */


  function triggerTabHide(self) {
    var element = self.element,
        nextContent = self.content,
        tabContent = self.tabContent,
        nav = self.nav;

    var _ref11 = nav && tabPrivate.get(nav),
        tab = _ref11.tab,
        content = _ref11.content;

    var currentHeight = 0;
    /* istanbul ignore else */

    if (tabContent && hasClass(nextContent, fadeClass)) {
      [content, nextContent].forEach(function (c) {
        addClass(c, 'overflow-hidden');
      });
      currentHeight = content.scrollHeight ||
      /* istanbul ignore next */
      0;
    } // update relatedTarget and dispatch event


    showTabEvent.relatedTarget = tab;
    hiddenTabEvent.relatedTarget = element;
    dispatchEvent(element, showTabEvent);
    if (showTabEvent.defaultPrevented) return;
    addClass(nextContent, activeClass);
    removeClass(content, activeClass);
    /* istanbul ignore else */

    if (tabContent && hasClass(nextContent, fadeClass)) {
      var nextHeight = nextContent.scrollHeight;
      tabPrivate.set(element, {
        currentHeight: currentHeight,
        nextHeight: nextHeight
      });
      addClass(tabContent, collapsingClass);
      tabContent.style.height = "".concat(currentHeight, "px");
      reflow(tabContent);
      [content, nextContent].forEach(function (c) {
        removeClass(c, 'overflow-hidden');
      });
    }

    if (nextContent && hasClass(nextContent, fadeClass)) {
      setTimeout(function () {
        addClass(nextContent, showClass);
        emulateTransitionEnd(nextContent, function () {
          triggerTabShow(self);
        });
      }, 1);
    } else {
      addClass(nextContent, showClass);
      triggerTabShow(self);
    }

    dispatchEvent(tab, hiddenTabEvent);
  }
  /**
   * Returns the current active tab and its target content.
   * @param {Tab} self the `Tab` instance
   * @returns {Record<string, any>} the query result
   */


  function getActiveTab(self) {
    var nav = self.nav;
    var activeTabs = getElementsByClassName(activeClass, nav);
    /** @type {(HTMLElement)=} */

    var tab;
    /* istanbul ignore else */

    if (activeTabs.length === 1 && !dropdownMenuClasses.some(function (c) {
      return hasClass(activeTabs[0].parentElement, c);
    })) {
      var _activeTabs = _slicedToArray(activeTabs, 1);

      tab = _activeTabs[0];
    } else if (activeTabs.length > 1) {
      tab = activeTabs[activeTabs.length - 1];
    }

    var content = tab ? getTargetElement(tab) : null;
    return {
      tab: tab,
      content: content
    };
  }
  /**
   * Returns a parent dropdown.
   * @param {HTMLElement} element the `Tab` element
   * @returns {HTMLElement?} the parent dropdown
   */


  function getParentDropdown(element) {
    var dropdown = closest(element, ".".concat(dropdownMenuClasses.join(',.')));
    return dropdown ? querySelector(".".concat(dropdownMenuClasses[0], "-toggle"), dropdown) : null;
  }
  /**
   * Toggles on/off the `click` event listener.
   * @param {Tab} self the `Tab` instance
   * @param {boolean=} add when `true`, event listener is added
   */


  function toggleTabHandler(self, add) {
    var action = add ? addListener : removeListener;
    action(self.element, mouseclickEvent, tabClickHandler);
  } // TAB EVENT HANDLER
  // =================

  /**
   * Handles the `click` event listener.
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Event` object
   */


  function tabClickHandler(e) {
    var self = getTabInstance(this);
    /* istanbul ignore next: must filter */

    if (!self) return;
    e.preventDefault();
    self.show();
  } // TAB DEFINITION
  // ==============

  /** Creates a new `Tab` instance. */


  var Tab = /*#__PURE__*/function (_BaseComponent10) {
    _inherits(Tab, _BaseComponent10);

    var _super11 = _createSuper(Tab);

    /**
     * @param {HTMLElement | string} target the target element
     */
    function Tab(target) {
      var _this13;

      _classCallCheck(this, Tab);

      _this13 = _super11.call(this, target); // bind

      var self = _assertThisInitialized(_this13); // initialization element


      var element = self.element;
      var content = getTargetElement(element); // no point initializing a tab without a corresponding content

      if (!content) return _possibleConstructorReturn(_this13);
      var nav = closest(element, '.nav');
      var container = closest(content, '.tab-content');
      /** @type {HTMLElement?} */

      self.nav = nav;
      /** @type {HTMLElement} */

      self.content = content;
      /** @type {HTMLElement?} */

      self.tabContent = container; // event targets

      /** @type {HTMLElement?} */

      self.dropdown = getParentDropdown(element); // show first Tab instance of none is shown
      // suggested on #432

      var _getActiveTab = getActiveTab(self),
          tab = _getActiveTab.tab;

      if (nav && !tab) {
        var firstTab = querySelector(tabSelector, nav);
        var firstTabContent = firstTab && getTargetElement(firstTab);
        /* istanbul ignore else */

        if (firstTabContent) {
          addClass(firstTab, activeClass);
          addClass(firstTabContent, showClass);
          addClass(firstTabContent, activeClass);
          setAttribute(element, ariaSelected, 'true');
        }
      } // add event listener


      toggleTabHandler(self, true);
      return _this13;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Tab, [{
      key: "name",
      get: function get() {
        return tabComponent;
      }
      /* eslint-enable */
      // TAB PUBLIC METHODS
      // ==================

      /** Shows the tab to the user. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            nextContent = self.content,
            nav = self.nav,
            dropdown = self.dropdown;
        /* istanbul ignore else */

        if (!(nav && Timer.get(nav)) && !hasClass(element, activeClass)) {
          var _getActiveTab2 = getActiveTab(self),
              tab = _getActiveTab2.tab,
              content = _getActiveTab2.content;
          /* istanbul ignore else */


          if (nav) tabPrivate.set(nav, {
            tab: tab,
            content: content
          }); // update relatedTarget and dispatch

          hideTabEvent.relatedTarget = element;
          dispatchEvent(tab, hideTabEvent);
          if (hideTabEvent.defaultPrevented) return;
          addClass(element, activeClass);
          setAttribute(element, ariaSelected, 'true');
          var activeDropdown = getParentDropdown(tab);

          if (activeDropdown && hasClass(activeDropdown, activeClass)) {
            removeClass(activeDropdown, activeClass);
          }
          /* istanbul ignore else */


          if (nav) {
            var toggleTab = function toggleTab() {
              removeClass(tab, activeClass);
              setAttribute(tab, ariaSelected, 'false');
              if (dropdown && !hasClass(dropdown, activeClass)) addClass(dropdown, activeClass);
            };

            if (hasClass(content, fadeClass) || hasClass(nextContent, fadeClass)) {
              Timer.set(nav, toggleTab, 1);
            } else toggleTab();
          }

          removeClass(content, showClass);

          if (hasClass(content, fadeClass)) {
            emulateTransitionEnd(content, function () {
              return triggerTabHide(self);
            });
          } else {
            triggerTabHide(self);
          }
        }
      }
      /** Removes the `Tab` component from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        toggleTabHandler(this);

        _get(_getPrototypeOf(Tab.prototype), "dispose", this).call(this);
      }
    }]);

    return Tab;
  }(BaseComponent);

  ObjectAssign(Tab, {
    selector: tabSelector,
    init: tabInitCallback,
    getInstance: getTabInstance
  });
  /** @type {string} */

  var toastString = 'toast';
  /** @type {string} */

  var toastComponent = 'Toast';
  /* Native JavaScript for Bootstrap 5 | Toast
  -------------------------------------------- */
  // TOAST PRIVATE GC
  // ================

  var toastSelector = ".".concat(toastString);
  var toastDismissSelector = "[".concat(dataBsDismiss, "=\"").concat(toastString, "\"]");
  var toastToggleSelector = "[".concat(dataBsToggle, "=\"").concat(toastString, "\"]");
  var showingClass = 'showing';
  /** @deprecated */

  var hideClass = 'hide';
  var toastDefaults = {
    animation: true,
    autohide: true,
    delay: 5000
  };
  /**
   * Static method which returns an existing `Toast` instance associated
   * to a target `Element`.
   *
   * @type {BSN.GetInstance<Toast>}
   */

  var getToastInstance = function getToastInstance(element) {
    return getInstance(element, toastComponent);
  };
  /**
   * A `Toast` initialization callback.
   * @type {BSN.InitCallback<Toast>}
   */


  var toastInitCallback = function toastInitCallback(element) {
    return new Toast(element);
  }; // TOAST CUSTOM EVENTS
  // ===================


  var showToastEvent = OriginalEvent("show.bs.".concat(toastString));
  var shownToastEvent = OriginalEvent("shown.bs.".concat(toastString));
  var hideToastEvent = OriginalEvent("hide.bs.".concat(toastString));
  var hiddenToastEvent = OriginalEvent("hidden.bs.".concat(toastString)); // TOAST PRIVATE METHODS
  // =====================

  /**
   * Executes after the toast is shown to the user.
   * @param {Toast} self the `Toast` instance
   */

  function showToastComplete(self) {
    var element = self.element,
        options = self.options;
    removeClass(element, showingClass);
    Timer.clear(element, showingClass);
    dispatchEvent(element, shownToastEvent);
    /* istanbul ignore else */

    if (options.autohide) {
      Timer.set(element, function () {
        return self.hide();
      }, options.delay, toastString);
    }
  }
  /**
   * Executes after the toast is hidden to the user.
   * @param {Toast} self the `Toast` instance
   */


  function hideToastComplete(self) {
    var element = self.element;
    removeClass(element, showingClass);
    removeClass(element, showClass);
    addClass(element, hideClass); // B/C

    Timer.clear(element, toastString);
    dispatchEvent(element, hiddenToastEvent);
  }
  /**
   * Executes before hiding the toast.
   * @param {Toast} self the `Toast` instance
   */


  function hideToast(self) {
    var element = self.element,
        options = self.options;
    addClass(element, showingClass);

    if (options.animation) {
      reflow(element);
      emulateTransitionEnd(element, function () {
        return hideToastComplete(self);
      });
    } else {
      hideToastComplete(self);
    }
  }
  /**
   * Executes before showing the toast.
   * @param {Toast} self the `Toast` instance
   */


  function showToast(self) {
    var element = self.element,
        options = self.options;
    Timer.set(element, function () {
      removeClass(element, hideClass); // B/C

      reflow(element);
      addClass(element, showClass);
      addClass(element, showingClass);

      if (options.animation) {
        emulateTransitionEnd(element, function () {
          return showToastComplete(self);
        });
      } else {
        showToastComplete(self);
      }
    }, 17, showingClass);
  }
  /**
   * Toggles on/off the `click` event listener.
   * @param {Toast} self the `Toast` instance
   * @param {boolean=} add when `true`, it will add the listener
   */


  function toggleToastHandlers(self, add) {
    var action = add ? addListener : removeListener;
    var element = self.element,
        triggers = self.triggers,
        dismiss = self.dismiss,
        options = self.options;
    /* istanbul ignore else */

    if (dismiss) {
      action(dismiss, mouseclickEvent, self.hide);
    }
    /* istanbul ignore else */


    if (options.autohide) {
      [focusinEvent, focusoutEvent, mouseenterEvent, mouseleaveEvent].forEach(function (e) {
        return action(element, e, interactiveToastHandler);
      });
    }
    /* istanbul ignore else */


    if (triggers.length) {
      triggers.forEach(function (btn) {
        return action(btn, mouseclickEvent, toastClickHandler);
      });
    }
  } // TOAST EVENT HANDLERS
  // ====================

  /**
   * Executes after the instance has been disposed.
   * @param {Toast} self the `Toast` instance
   */


  function completeDisposeToast(self) {
    Timer.clear(self.element, toastString);
    toggleToastHandlers(self);
  }
  /**
   * Handles the `click` event listener for toast.
   * @param {MouseEvent} e the `Event` object
   */


  function toastClickHandler(e) {
    var target = e.target;
    var trigger = target && closest(target, toastToggleSelector);
    var element = trigger && getTargetElement(trigger);
    var self = element && getToastInstance(element);
    /* istanbul ignore else */

    if (trigger && trigger.tagName === 'A') e.preventDefault();
    self.relatedTarget = trigger;
    self.show();
  }
  /**
   * Executes when user interacts with the toast without closing it,
   * usually by hovering or focusing it.
   *
   * @this {HTMLElement}
   * @param {MouseEvent} e the `Toast` instance
   */


  function interactiveToastHandler(e) {
    var element = this;
    var self = getToastInstance(element);
    var type = e.type,
        relatedTarget = e.relatedTarget;
    /* istanbul ignore next: a solid filter is required */

    if (!self || element === relatedTarget || element.contains(relatedTarget)) return;

    if ([mouseenterEvent, focusinEvent].includes(type)) {
      Timer.clear(element, toastString);
    } else {
      Timer.set(element, function () {
        return self.hide();
      }, self.options.delay, toastString);
    }
  } // TOAST DEFINITION
  // ================

  /** Creates a new `Toast` instance. */


  var Toast = /*#__PURE__*/function (_BaseComponent11) {
    _inherits(Toast, _BaseComponent11);

    var _super12 = _createSuper(Toast);

    /**
     * @param {HTMLElement | string} target the target `.toast` element
     * @param {BSN.Options.Toast=} config the instance options
     */
    function Toast(target, config) {
      var _this14;

      _classCallCheck(this, Toast);

      _this14 = _super12.call(this, target, config); // bind

      var self = _assertThisInitialized(_this14);

      var element = self.element,
          options = self.options; // set fadeClass, the options.animation will override the markup

      if (options.animation && !hasClass(element, fadeClass)) addClass(element, fadeClass);else if (!options.animation && hasClass(element, fadeClass)) removeClass(element, fadeClass); // dismiss button

      /** @type {HTMLElement?} */

      self.dismiss = querySelector(toastDismissSelector, element); // toast can have multiple triggering elements

      /** @type {HTMLElement[]} */

      self.triggers = _toConsumableArray(querySelectorAll(toastToggleSelector, getDocument(element))).filter(function (btn) {
        return getTargetElement(btn) === element;
      }); // bind

      self.show = self.show.bind(self);
      self.hide = self.hide.bind(self); // add event listener

      toggleToastHandlers(self, true);
      return _this14;
    }
    /* eslint-disable */

    /**
     * Returns component name string.
     */


    _createClass(Toast, [{
      key: "name",
      get: function get() {
        return toastComponent;
      }
      /**
       * Returns component default options.
       */

    }, {
      key: "defaults",
      get: function get() {
        return toastDefaults;
      }
      /* eslint-enable */

      /**
       * Returns *true* when toast is visible.
       */

    }, {
      key: "isShown",
      get: function get() {
        return hasClass(this.element, showClass);
      } // TOAST PUBLIC METHODS
      // ====================

      /** Shows the toast. */

    }, {
      key: "show",
      value: function show() {
        var self = this;
        var element = self.element,
            isShown = self.isShown;
        /* istanbul ignore else */

        if (element && !isShown) {
          dispatchEvent(element, showToastEvent);
          if (showToastEvent.defaultPrevented) return;
          showToast(self);
        }
      }
      /** Hides the toast. */

    }, {
      key: "hide",
      value: function hide() {
        var self = this;
        var element = self.element,
            isShown = self.isShown;
        /* istanbul ignore else */

        if (element && isShown) {
          dispatchEvent(element, hideToastEvent);
          if (hideToastEvent.defaultPrevented) return;
          hideToast(self);
        }
      }
      /** Removes the `Toast` component from the target element. */

    }, {
      key: "dispose",
      value: function dispose() {
        var self = this;
        var element = self.element,
            isShown = self.isShown;
        /* istanbul ignore else */

        if (isShown) {
          removeClass(element, showClass);
        }

        completeDisposeToast(self);

        _get(_getPrototypeOf(Toast.prototype), "dispose", this).call(this);
      }
    }]);

    return Toast;
  }(BaseComponent);

  ObjectAssign(Toast, {
    selector: toastSelector,
    init: toastInitCallback,
    getInstance: getToastInstance
  });
  /**
   * Check if element matches a CSS selector.
   *
   * @param {HTMLElement} target
   * @param {string} selector
   * @returns {boolean}
   */

  function matches(target, selector) {
    return target.matches(selector);
  }
  /** @type {Record<string, any>} */


  var componentsList = {
    Alert: Alert,
    Button: Button,
    Carousel: Carousel,
    Collapse: Collapse,
    Dropdown: Dropdown,
    Modal: Modal,
    Offcanvas: Offcanvas,
    Popover: Popover,
    ScrollSpy: ScrollSpy,
    Tab: Tab,
    Toast: Toast,
    Tooltip: Tooltip
  };
  /**
   * Initialize all matched `Element`s for one component.
   * @param {BSN.InitCallback<any>} callback
   * @param {NodeList | Node[]} collection
   */

  function initComponentDataAPI(callback, collection) {
    _toConsumableArray(collection).forEach(function (x) {
      return callback(x);
    });
  }
  /**
   * Remove one component from a target container element or all in the page.
   * @param {string} component the component name
   * @param {ParentNode} context parent `Node`
   */


  function removeComponentDataAPI(component, context) {
    var compData = Data.getAllFor(component);

    if (compData) {
      _toConsumableArray(compData).forEach(function (x) {
        var _x = _slicedToArray(x, 2),
            element = _x[0],
            instance = _x[1];

        if (context.contains(element)) instance.dispose();
      });
    }
  }
  /**
   * Initialize all BSN components for a target container.
   * @param {ParentNode=} context parent `Node`
   */


  function initCallback(context) {
    var lookUp = context && context.nodeName ? context : document;

    var elemCollection = _toConsumableArray(getElementsByTagName('*', lookUp));

    ObjectKeys(componentsList).forEach(function (comp) {
      var _componentsList$comp = componentsList[comp],
          init = _componentsList$comp.init,
          selector = _componentsList$comp.selector;
      initComponentDataAPI(init, elemCollection.filter(function (item) {
        return matches(item, selector);
      }));
    });
  }
  /**
   * Remove all BSN components for a target container.
   * @param {ParentNode=} context parent `Node`
   */


  function removeDataAPI(context) {
    var lookUp = context && context.nodeName ? context : document;
    ObjectKeys(componentsList).forEach(function (comp) {
      removeComponentDataAPI(comp, lookUp);
    });
  } // bulk initialize all components


  if (document.body) initCallback();else {
    addListener(document, 'DOMContentLoaded', function () {
      return initCallback();
    }, {
      once: true
    });
  }
  var BSN = {
    Alert: Alert,
    Button: Button,
    Carousel: Carousel,
    Collapse: Collapse,
    Dropdown: Dropdown,
    Modal: Modal,
    Offcanvas: Offcanvas,
    Popover: Popover,
    ScrollSpy: ScrollSpy,
    Tab: Tab,
    Toast: Toast,
    Tooltip: Tooltip,
    initCallback: initCallback,
    removeDataAPI: removeDataAPI,
    Version: Version,
    EventListener: Listener
  };
  return BSN;
});
